import {Component, HostListener, Input, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AppUtils} from "../../../core/config/app.utils";
import {CustomerService} from "../../../core/services/customer.service";
import {ItineraryService} from "../../../core/services/itinerary.service";
import {ItineraryTemplatesService} from "../../../core/services/itinerary-templates.service";
import {NzMessageService} from "ng-zorro-antd/message";
import {Location} from "@angular/common";
import {LoadingService} from "../../../core/services/loading.service";
import {OtherContentService} from "../../../core/services/other-content.service";
import * as _ from "lodash";
import * as moment from "moment";
import { CurrencyService } from "../../../core/services/currency.service";
import { PrivilegeService } from "../../../core/services/privilege.service";
import { SETTINGS } from "../../../core/config/common.settings";
import { NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs } from "ng-zorro-antd/upload";
import { UploadService } from "../../../core/services/upload.service";
import { NzModalService } from "ng-zorro-antd/modal";
import {
  AddEditDestinationContentComponent
} from "../add-edit-content-modal/add-edit-destination-content/add-edit-destination-content.component";
import {
  ViewDestinationContentComponent
} from "../view-content-modal/view-destination-content/view-destination-content.component";
import {
  AddEditAccommodationContentComponent
} from "../add-edit-content-modal/add-edit-accommodation-content/add-edit-accommodation-content.component";
import {
  ViewAccommodationContentComponent
} from "../view-content-modal/view-accommodation-content/view-accommodation-content.component";
import {
  AddEditTransportContentComponent
} from "../add-edit-content-modal/add-edit-transport-content/add-edit-transport-content.component";
import {
  AddEditExperiencesContentComponent
} from "../add-edit-content-modal/add-edit-experiences-content/add-edit-experiences-content.component";
import {
  ViewExperiencesContentComponent
} from "../view-content-modal/view-experiences-content/view-experiences-content.component";
import {
  ViewTransportContentComponent
} from "../view-content-modal/view-transport-content/view-transport-content.component";
import {AuthService} from "../../../modules/auth/services/auth.service";
import {SettingService} from "../../../core/services/setting.service";
import {LanguageService} from "../../../core/services/language.service";
import {ActionAlert} from "../../../core/dto/actionAlert";
import {Clipboard} from "@angular/cdk/clipboard";
import {OpenAiService} from "../../../core/services/open-ai.service";
import {AddImageModelComponent} from "../add-image-model/add-image-model.component";
import {ImageApiService} from "../../../core/services/image-api.service";
import {getAccommodationPerDate, isDateInRange} from "../../../core/ult-functions/accommodation";
import {determineIsTimeExpired, timeUntil24HoursExpires} from "../../../core/ult-functions/time";
import { AgentService } from "../../../core/services/agent.service";
import { ChargebeeService } from "../../../core/services/chargebee.service";
import {geoJSONManager} from "../../../core/ult-functions/geo";
import {MapboxService} from "../../../core/services/mapbox.service";
import {CountryService} from "../../../core/services/country.service";
import {JsReportService} from "../../../core/services/js-report.service";
import { CanComponentDeactivate } from "../../../core/guards/unsaved-changes.guard";
import {TranslocoService} from "@ngneat/transloco";
import {
  fromEvent,
  interval,
  merge,
  Observable,
  of,
  share,
  Subscription,
  takeUntil,
  timer
} from "rxjs";
import {AddEditCustomerComponent} from "../../customers/add-edit-customer/add-edit-customer.component";
import {destinationMergeChecker} from "../../../core/ult-functions/destination";
import {AddEditRemarksTitleComponent} from "../add-edit-remarks-title/add-edit-remarks-title.component";
import {CategoryService} from "../../../core/services/category.service";
import {TagService} from "../../../core/services/tag.service";
import {AddEditTagsComponent} from "../../../modules/shared/add-edit-tags/add-edit-tags.component";
import {ExportContentComponent} from "../../../modules/shared/export-content/export-content.component";
import {debounceTime, distinctUntilChanged, filter, map, switchMap} from "rxjs/operators";
import {OnlineStatusService} from "../../../core/services/online-status.service";
import {ExperiencesDragComponent} from "../experiences-drag/experiences-drag.component";
import {displayTitle} from "../../../core/ult-functions/common";
import {MoveDeleteDaysComponent} from "../move-delete-days/move-delete-days.component";
import {WordReportService} from "../../../core/services/word-report.service";
import {amountParser, currencyFormatter} from "../../../core/ult-functions/currency-calculation";
import { environment } from '../../../../environments/environment';
import { driver, Driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import Quill from 'quill';
const getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

@Component({
  selector: "app-add-edit-itinery",
  templateUrl: "./add-edit-itinery.component.html",
  styleUrls: ["./add-edit-itinery.component.scss"],
})
export class AddEditItineryComponent implements OnInit, OnDestroy, CanComponentDeactivate {
  isAdd = false;
  rId: any;
  rIti: any;
  isTemplateAdd = false;
  tourForm: any;
  featuredForm: any;
  itineraryForm: any;
  additionalNotesForm: any;
  costingForm: any;
  formErrors: any;
  formDestinationErrors: any;
  tabIndex = 0;

  cardLoading: boolean;
  btnLoading = false;
  protected itinerarySaveInProgress = false;

  activeCustomers: any[] = [];
  destinations: any[] = [];
  accommodations: any = [];
  singleItinerary: any;

  private tabSessionId = this.getTabSessionId();

  destination: any = {};
  featuredImage: any = [];
  fileList: NzUploadFile[] = [];
  previewImage: string | undefined = "";
  previewVisible = false;
  images: any = [];
  overviewImages: any = [];

  get allImages(): string[] {
    return Array.from(new Set([...(this.images || []), ...(this.overviewImages || [])]));
  }

  updatedTime: any = null;
  private autoUpdateInterval: any;
  currencies: any[] = [];
  recentlyItinerary: any;

  departureBoxChecked = true;
  placeholderPath: any = "../assets/img/placeholder-image.png";
  actionMessage = new ActionAlert();

  daysArrFormValid = true;
  fixedPercentSymbol: any[] = [];
  private langChangeSub?: Subscription;
  numOfPax = 0;

  overviewDescription = "";
  remarksTips = "";
  remarks = "";

  selectedLanguages: any = [];
  languages: any[] = [];
  paymentLink = "";
  isValidUrl = true;

  aiContent: any;
  isAiContentPresent = false;
  isAiHighlightPresent = false;
  searchImageText = "";
  brand: any;
  draggedIndex: number | null = null;

  protected readonly SETTINGS = SETTINGS;

  // cost Settings
  isSubTotalManual = false;
  isDynamicPricing = false;

  // view settings
  costingBoxChecked = false;
  mileageBoxChecked = false;
  travelTimeBoxChecked = false;
  vehicleNameBoxChecked = false;
  vehicleImageBoxChecked = false;
  remarksTipsBoxChecked = false;
  itineraryTitleBoxChecked = false;
  itineraryReferenceNumberBoxChecked = false;
  tourOperatorBoxChecked = false;
  companyInformationBoxChecked = false;
  hotelRatingBoxChecked = false;
  hotelDescriptionBoxChecked = false;
  hotelWebsiteBoxChecked = false;
  hotelImageBoxChecked = false;
  websiteLinkBoxChecked = false;
  paymentLinkBoxChecked = false;
  customerInformationBoxChecked = false;
  displayMapTopsideBoxChecked = false;
  thumbnailBoxChecked = false;
  hideDaywiseInclusionsExclusionsBoxChecked = false;
  includeBadgeBoxChecked = false;
  excludeBadgeBoxChecked = false;
  pricingRemarksBoxChecked = false;
  additionalNotesBoxChecked = false;
  accommodationNoteBoxChecked = true;
  accommodationRoomsBoxChecked = false;
  transportNoteBoxChecked = true;
  experiencesNoteBoxChecked = true;
  hideExperiencesTimesBoxChecked = false;
  mapType = "NAV";

  // toggle
  toggleCostBreakDown = false;
  toggleDayAdditionalCosts: boolean[] = [];
  toggleDayInclusionsExclusions: boolean[] = [];

  // exclude pre
  excludeCost: any = [];

  private intervalId: any;
  timeLeft: any;
  isNotExpiredRealTime = true;
  themeType = "";

  titleForm: any;
  FormTitleErrors: any;

  activeAgents: any[] = [];
  activeCategories: any[] = [];
  activeTags: any[] = [];
  agentContacts: any[] = [];

  // TODO moving forward need to write a common component(using in itineraries page as well) for email via modal,
  sendEmailIsVisible = false;
  sendEmailConfirmIsVisible = false;
  emailForm: any;
  formErrorsEmail: any = {
    sendEmailTo: {},
    sendEmailCc: {},
    sendEmailSubject: {},
  };
  attachWithPDFChecked = false;
  sendInfo: any;
  modalTitle: any;
  modalTitleConfirmBox: any;
  subject = "";
  protected itineraryId: any;

  protected countries: any = [];
  protected citiesByCountry: any = [];
  countriesJson: any = [];

  private originalPayload: any;
  costingType: any[] = [];
  mapTypeOptions: any[] = [];
  protected readonly displayTitle = displayTitle;
  private idleSub!: Subscription;
  private pollSub!: Subscription;
  private extendSub!: Subscription;

  seasonPricingIsVisible = false;
  seasonPricingType = '';
  seasonPricingColName = '';
  isCostColumn = true;
  headerIndex: null | number = null;

  private addItineraryTour!: Driver;
  private editItineraryTour!: Driver;
  private isTour = false;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private customerService: CustomerService,
    private router: Router,
    private itineraryService: ItineraryService,
    private itineraryTemplatesService: ItineraryTemplatesService,
    private message: NzMessageService,
    private _location: Location,
    private clipboard: Clipboard,
    private loadingService: LoadingService,
    private otherContentService: OtherContentService,
    private currencyService: CurrencyService,
    private uploadService: UploadService,
    private nzModalService: NzModalService,
    private authService: AuthService,
    private settingService: SettingService,
    private languageService: LanguageService,
    private openAiService: OpenAiService,
    private agentService: AgentService,
    private location: Location,
    private chargebeeService: ChargebeeService,
    private messageService: NzMessageService,
    private mapBoxService: MapboxService,
    private countryService: CountryService,
    private reportService: JsReportService,
    private modal: NzModalService,
    private categoryService: CategoryService,
    private tagService: TagService,
    private wordReportService: WordReportService,
    private translocoService: TranslocoService,
  ) {
    this.cardLoading = true;

    this.formErrors = {
      type: {},
      customer: {},
      currency: {},
      noOfDays: {},
      language: {},
      isDatesOptional: {},
      secondaryCurrency: {},
      exchangeRate: {},
      pax: {
        adults: {},
        children: {},
        infants: {},
      },
    };
    this.formDestinationErrors = {
      description: {},
      image: {},
    };
    this.FormTitleErrors = {
      title: {}
    };
  }

  get mode(): 'itinerary' | 'template' {
    return this.router.url.includes('/template-itinerary') ? 'template' : 'itinerary';
  }

  get activeService(): ItineraryService | ItineraryTemplatesService {
    return this.mode === 'template' ? this.itineraryTemplatesService : this.itineraryService;
  }

  private getViewTypeOptions(): Array<{ value: string; label: string }> {
    const lang = this.translocoService.getActiveLang();
    const f = SETTINGS.VIEW_TYPES.filter(i => i.language === lang);
    return (f.length ? f : SETTINGS.VIEW_TYPES.filter(i => i.language === 'en'))
      .map(({ value, label }) => ({ value, label }));
  }

  private getMapTypeOptions(): Array<{ value: string; label: string }> {
    const lang = this.translocoService.getActiveLang();
    const f = SETTINGS.MAP_TYPES.filter(i => i.language === lang);
    return (f.length ? f : SETTINGS.MAP_TYPES.filter(i => i.language === 'en'))
      .map(({ value, label }) => ({ value, label }));
  }
  private getFixedPercentOptions(): Array<{ value: string; label: string; emoji: string }> {
    const lang = this.translocoService.getActiveLang();
    const filtered = SETTINGS.FIXED_PERCENT_SYMBOL.filter(item => item.language === lang);
    return (filtered.length ? filtered : SETTINGS.FIXED_PERCENT_SYMBOL.filter(item => item.language === 'en'))
      .map(({ value, label, emoji }) => ({ value, label, emoji }));
  }
  ngOnInit(): void {
    this.fixedPercentSymbol = this.getFixedPercentOptions();
    this.costingType = this.getViewTypeOptions();
    this.mapTypeOptions = this.getMapTypeOptions();
    this.langChangeSub = this.translocoService.langChanges$.subscribe(() => {
      this.fixedPercentSymbol = this.getFixedPercentOptions();
      this.costingType = this.getViewTypeOptions();
      this.mapTypeOptions = this.getMapTypeOptions();
    });
    this.getCountries().then();
    this.emailForm = this.fb.group({
      sendEmailTo: [[], [Validators.required, this.emailValidator]],
      sendEmailCc: [[], [this.emailValidator]],
      sendEmailSubject: [this.subject, [Validators.required]],
    });
    this.emailForm.valueChanges.subscribe((form: any) => {
      AppUtils.getFormErrors(this.emailForm, this.formErrorsEmail);
    });
    this.actionMessage = new ActionAlert(
      true,
      true,
      this.t("itineraries.addEditItinerary.messages.shareLinkInfo"),
      "info"
    );
    // Set Add or Update Page
    this.rId = this.route.snapshot.paramMap.get("id");
    this.rIti = this.route.snapshot.paramMap.get("iti");
    this.isAdd = !this.rId;
    this.isTemplateAdd = this.router.url.includes('/itineraries/template/add');
    this.getCurrencies().then();
    this.getLanguages().then();

    this.route.queryParams.subscribe(params => {
      this.isTour = params['tour'] === 'true';
      this.isTemplateAdd = this.router.url.includes('/itineraries/template/add');

      if (this.isTour && this.isAdd && this.rIti === null) {
        this.initializeAddTour();

        setTimeout(() => {
          this.addItineraryTour.drive();
        }, 300);

      } else if (this.isTour && !this.isAdd) {
        this.initializeEditTour();

        setTimeout(() => {
          this.editItineraryTour.drive();
        }, 300);
      }
    });

    if (this.isAdd && this.rIti !== null) {
      this.tourForm = this.fb.group({
        agent: [""],
        category: [""],
        tags: [[]],
        selectedContact: [""],
        customer: ["", [Validators.required]],
        currency: ["", [Validators.required]],
        secondaryCurrency: [""],
        exchangeRate: [""],
        type: ["B2C", [Validators.required]],
        themeType: ["THEME_1"],
        noOfDays: [null, [Validators.required]],
        tourDates: [null, [Validators.required]],
        startDate: [null, [Validators.required]],
        endDate: [null, [Validators.required]],
        referenceNo: [""],
        language: ["", [Validators.required]],
        isDatesOptional: [false],
        season: [null],
        pax: this.fb.group({
          adults: ["1", [Validators.required]],
          children: ["0", [Validators.required]],
          infants: ["0", [Validators.required]],
        }),
      });

      Promise.all([
        this.getActiveCustomers(),
        this.recentlyCurrencyAndLanguageGet(),
        this.findBrand(),
        this.getActiveAgents(),
        this.getActiveCategories()
      ]).then(() => {
        const fetchService = this.isTemplateAdd ? this.itineraryTemplatesService : this.activeService;
        fetchService.getItineraryById({
          id: this.rIti,
        }).then((res) => {
          this.singleItinerary = res;
          this.tourForm.patchValue({
            category: this.singleItinerary?.tour?.category?._id || "",
            tags: this.singleItinerary.tour.tags ,
            agent: this.singleItinerary?.tour?.agent?._id || "",
            selectedContact: this.singleItinerary?.tour?.selectedContact?._id || "",
            type: this.singleItinerary?.tour.type,
            themeType: this.singleItinerary?.tour.themeType,
            customer: this.singleItinerary?.tour?.customer?._id || "",
            currency: this.singleItinerary?.tour.currency,
            secondaryCurrency: this.singleItinerary?.tour?.secondaryCurrency || "",
            exchangeRate: this.singleItinerary?.tour?.exchangeRate || "",
            noOfDays: this.singleItinerary?.tour.noOfDays,
            isDatesOptional: this.singleItinerary?.tour?.isDatesOptional || false,
            tourDates: [this.singleItinerary?.tour?.startDate , this.singleItinerary?.tour.endDate],
            startDate: this.singleItinerary?.tour.startDate,
            endDate: this.singleItinerary?.tour.endDate,
            referenceNo: this.singleItinerary?.tour.referenceNo,
            language: this.singleItinerary?.tour.language,
            season: this.singleItinerary?.tour?.season?._id || null,
            pax: this.singleItinerary?.tour.pax
          });
          this.cardLoading = false;
        });
      });

      this.itineraryFormValueChanges();

    }

    if (this.isAdd && this.rIti === null) {
      Promise.all([
        this.getActiveCustomers(),
        this.recentlyCurrencyAndLanguageGet(),
        this.findBrand(),
        this.getActiveAgents(),
        this.getActiveCategories()
      ]).then(async () => {
        if (this.isTemplateAdd) {
          const templateId = this.route.snapshot.queryParamMap.get('templateId');
          if (templateId) {
            const res = await this.itineraryTemplatesService.getItineraryById({ id: templateId });
            this.singleItinerary = res;
            const tour = this.singleItinerary?.tour || {};
            this.tourForm.patchValue({
              category: tour.category?._id || "",
              tags: tour.tags || [],
              agent: tour.agent?._id || "",
              selectedContact: tour.selectedContact?._id || "",
              type: tour.type || "B2C",
              themeType: tour.themeType || "THEME_1",
              customer: tour.customer?._id || "",
              currency: tour.currency || "",
              secondaryCurrency: tour.secondaryCurrency || "",
              exchangeRate: tour.exchangeRate || "",
              noOfDays: tour.noOfDays || null,
              isDatesOptional: tour.isDatesOptional || false,
              tourDates: tour.startDate && tour.endDate ? [tour.startDate, tour.endDate] : null,
              startDate: tour.startDate || null,
              endDate: tour.endDate || null,
              referenceNo: tour.referenceNo || "",
              language: tour.language || "",
              season: tour.season?._id || null,
              pax: tour.pax || { adults: "1", children: "0", infants: "0" }
            }, { emitEvent: false });

            if (tour.isDatesOptional) {
              this.tourForm.get("tourDates")?.clearValidators();
              this.tourForm.get("startDate")?.clearValidators();
              this.tourForm.get("endDate")?.clearValidators();
              this.tourForm.get("tourDates")?.updateValueAndValidity({ emitEvent: false });
              this.tourForm.get("startDate")?.updateValueAndValidity({ emitEvent: false });
              this.tourForm.get("endDate")?.updateValueAndValidity({ emitEvent: false });
            }

            if (tour.type === "B2B") {
              this.tourForm.get("customer")?.clearValidators();
              this.tourForm.get("customer")?.updateValueAndValidity({ emitEvent: false });
            } else {
              this.tourForm.get("customer")?.setValidators([Validators.required]);
              this.tourForm.get("customer")?.updateValueAndValidity({ emitEvent: false });
            }

            if (tour.secondaryCurrency) {
              this.tourForm.get("exchangeRate")?.addValidators([Validators.required, Validators.min(0)]);
              this.tourForm.get("exchangeRate")?.updateValueAndValidity({ emitEvent: false });
            }
          }
        } else {
          this.tourForm.patchValue({ agent: this.recentlyItinerary.agent });
          if (this.recentlyItinerary.agent === "null" || this.recentlyItinerary.agent === "undefined") {
            this.tourForm.patchValue({ agent: null });
          }
        }

        const user = await this.authService.getLoggedInUser();
        const { payment } = this.brand;
        const subList = await this.chargebeeService.getSubscriptionByCustomerId(payment.customerId);
        if (subList?.length > 0) {
          if (subList[0].status === "cancelled") {
            this.determineRedirect(user, "admin/payment/portal");
          }
        } else {
          this.determineRedirect(user, "admin/payment/sub");
        }

        this.cardLoading = false;
      });

      this.tourForm = this.fb.group({
        agent: [""],
        category: [""],
        tags: [[]],
        selectedContact: [""],
        customer: ["", [Validators.required]],
        type: ["B2C", [Validators.required]],
        themeType: ["THEME_1"],
        currency: ["", [Validators.required]],
        secondaryCurrency: [""],
        exchangeRate: [""],
        noOfDays: [null, [Validators.required]],
        tourDates: [null, [Validators.required]],
        startDate: [null, [Validators.required]],
        endDate: [null, [Validators.required]],
        referenceNo: [""],
        language: ["", [Validators.required]],
        isDatesOptional: [false],
        season: [null],
        pax: this.fb.group({
          adults: ["1", [Validators.required]],
          children: ["0", [Validators.required]],
          infants: ["0", [Validators.required]],
        }),
      });

      this.itineraryFormValueChanges();

    }

    if (!this.isAdd) {

      Promise.all([this.loadItineraryByID()]).then(async () => {
        this.cardLoading = false;
        this.setFeaturedContent();
        this.setTitleContent();
        this.setViewSettings();
        this.setCostSettings();
        this.newCalculateTotalCost();
        this.setLinks();
        this.setRemarks();

        this.themeType = this.singleItinerary?.tour.themeType;
        this.overviewDescription = this.singleItinerary.days[this.tabIndex].overviewDescription;
        this.remarksTips = this.singleItinerary.days[this.tabIndex]?.remarksTips || "";
        this.accommodations = getAccommodationPerDate(this.singleItinerary.days[this.tabIndex].date, this.singleItinerary.accommodation);

        if (this.singleItinerary?.tour?.type === "B2B" && this.singleItinerary?.b2b?.time) {
          this.intervalId = setInterval(() => {
            this.isNotExpiredRealTime = determineIsTimeExpired(this.singleItinerary.b2b.time);
          }, 1000); // Run every 1 second
        }
        this.originalPayload = _.cloneDeep(this.getCurrentUpdatePayload());
        this.startValueChangesWatcher();
        this.extendLockStateSub();
      });
      this.featuredForm = this.fb.group({
        description: ["", [Validators.required]],
        image: ["", [Validators.required]],
        plaintextDescription: [""],
        isSliderEnabled: [false],
        sliderImages: [[]],
      });

      this.featuredForm.valueChanges.subscribe((form: any) => {
        this.formDestinationErrors = AppUtils.getFormErrors(
          this.featuredForm,
          this.formDestinationErrors
        );
        this.featuredForm.get('plaintextDescription')?.setValue(
          this.stripHtmlForMeta(form.description ?? ''),
          { emitEvent: false }
        );
      });
      this.titleForm = this.fb.group({
        title: ["", [Validators.required]],
      });

      this.titleForm.valueChanges.subscribe((form: any) => {
        this.FormTitleErrors = AppUtils.getFormErrors(
          this.titleForm,
          this.FormTitleErrors
        );
      });
      this.itineraryForm = this.fb.group({
        inclusions: [""],
        exclusions: [""],
        policies: [""],
      });
      this.additionalNotesForm = this.fb.group({
        title: ["Additional Notes"],
        content: [""],
      });
      this.costingForm = this.fb.group({
        totalCost: [0],
        totalCostPerPerson: [0],
        markupRatio: [0],
        markupSymbol: ['PERCENT'],
        markup: [0],
        subTotal: [0],
        viewType: ['person'],
        additionalCosts: this.fb.array([]),
        totalAdditionalCost: [0],
        grandTotal: [0],
        personCost: [0],
        currencyConvert: this.fb.group({
          selectedCost: [''],
          exchangeRate: [0],
          exchangeCurrency: [''],
        }),
        costPerAdult: [0],
        costPerChild: [0],
        costPerInfant: [0],
        totalExperiences: [0],
        totalTransport: [0],
        totalAccommodation: [0],
        pricingRemarks: [''],
        dynamicPricing: this.fb.group({
          headers: this.fb.array<FormGroup>([]),
          rows: this.fb.array<FormArray<FormControl<any>>>([])
        }),
        paxCostingChecks: this.fb.group({
          perAdult: [true],
          perChild: [true],
          perInfant: [false],
        }),
      });

      this.costingForm.valueChanges.subscribe((form: any) => {
        const totalCost = this.costingForm.get("totalCost").value;
        const totalCostPerPerson = totalCost / this.numOfPax;
        const markupBefore = this.getFixedOrPercentageValue(
          form.markupSymbol,
          totalCost,
          form.markupRatio
        );
        const subTotal = totalCost + (this.brand.isMarkCostBefore ? markupBefore : 0);
        const totalAdditionalCost = form.additionalCosts.reduce(
          (sum: number, { cost, costCalSymbol }: any) =>
            sum + this.getFixedOrPercentageValue(costCalSymbol, subTotal, cost),
          0
        );
        const markupAfter = this.getFixedOrPercentageValue(
          form.markupSymbol,
          subTotal + totalAdditionalCost,
          form.markupRatio
        );
        const grandTotal = subTotal + totalAdditionalCost + (this.brand?.isMarkCostBefore === false ? markupAfter : 0);
        const personCost = this.calculatePersonCost(grandTotal);

        this.costingForm.patchValue(
          {
            totalCostPerPerson,
            markup: this.brand?.isMarkCostBefore === true ? markupBefore : markupAfter,
            subTotal,
            totalAdditionalCost,
            grandTotal,
            personCost,
          },
          { emitEvent: false }
        );
      });

      this.costingForm.get('paxCostingChecks').valueChanges.subscribe(() => {
        const grandTotal = this.costingForm.get('grandTotal').value;
        const personCost = this.calculatePersonCost(grandTotal);
        this.costingForm.patchValue({ personCost }, { emitEvent: false });
      });
      this.uploadService.onUploadedFileChange.subscribe(value => {
        this.loadingService.stop();
      });
    }
    if (!this.isAdd) {
      // //  Auto update every 3 min
      // this.autoUpdateInterval = setInterval(() => {
      //   this.updateItineraryContent(true).then();
      // }, 6500);
      // Update timeago
      setInterval(() => {
        this.getTimeAgo(this.updatedTime);
      }, 6500);
    }
    // this.userIdle();
  }

  private calculatePersonCost(grandTotal: number): number {
    const paxChecks = this.costingForm.get('paxCostingChecks')?.value || { perAdult: true, perChild: true, perInfant: false };
    const pax = this.singleItinerary?.tour?.pax;
    const adultCount = paxChecks.perAdult && pax ? (pax.adults || 0) : 0;
    const childCount = paxChecks.perChild && pax ? (pax.children || 0) : 0;
    const infantCount = paxChecks.perInfant && pax ? (pax.infants || 0) : 0;
    const checkedPaxCount = adultCount + childCount + infantCount;
    return checkedPaxCount > 0 ? grandTotal / checkedPaxCount : grandTotal / (this.numOfPax || 1);
  }

  itineraryFormValueChanges(): void {
    this.tourForm.get("type").valueChanges.subscribe((type: any) => {
      if (type) {
        if (type === "B2B") {
          this.tourForm.get("customer").clearValidators();
        } else {
          this.tourForm.get("customer").addValidators(Validators.required);
          this.tourForm.get("agent").reset();
          this.tourForm.get("selectedContact").reset();
        }
        this.tourForm.get("customer").updateValueAndValidity();
      }
    });

    this.tourForm.get("secondaryCurrency").valueChanges.subscribe((type: any) => {
      if (type) {
          this.tourForm.get("exchangeRate").addValidators([Validators.required, Validators.min(0)]);
          this.tourForm.get("exchangeRate").updateValueAndValidity();
      }
    });

    this.tourForm.get("isDatesOptional").valueChanges.subscribe((value: any) => {
      if (value) {
        this.tourForm.get("tourDates").clearValidators();
        this.tourForm.get("startDate").clearValidators();
        this.tourForm.get("endDate").clearValidators();

        this.tourForm.patchValue({
          tourDates: null,
          startDate: null,
          endDate: null
        });

        this.tourForm.get("tourDates").updateValueAndValidity();
        this.tourForm.get("endDate").updateValueAndValidity();
        this.tourForm.get("startDate").updateValueAndValidity();
      }else{
        this.tourForm.get("tourDates").addValidators([Validators.required]);
        this.tourForm.get("startDate").addValidators([Validators.required]);
        this.tourForm.get("endDate").addValidators([Validators.required]);

        this.tourForm.patchValue({
          noOfDays: null,
        });

        this.tourForm.get("tourDates").updateValueAndValidity();
        this.tourForm.get("endDate").updateValueAndValidity();
        this.tourForm.get("startDate").updateValueAndValidity();
      }
    });

    this.tourForm.get("tourDates").valueChanges.subscribe((tourDates: any) => {
      if (tourDates){
        if (tourDates[0] !== null && tourDates[1]  !== null) {
          const start = moment(tourDates[0]).startOf('day');
          const end = moment(tourDates[1]).startOf('day');
          const diff = end.diff(start, 'days') + 1;
          this.tourForm.patchValue(
            {
              startDate: tourDates[0],
              endDate: tourDates[1],
              noOfDays: diff,
            },
            { emitEvent: false }
          );
        }
      }
    });

    this.tourForm.get("agent")?.valueChanges.subscribe((value: any) => {
      if (value !== "") {
        this.tourForm.get("selectedContact").reset();
        const selectedAgent = this.activeAgents.find((agent: any) => agent._id === value);
        this.agentContacts = [...selectedAgent.contacts];
      }
    });

    this.tourForm.valueChanges.subscribe(({ type, tourDates }: any) => {
      this.formErrors = AppUtils.getFormErrors(
        this.tourForm,
        this.formErrors
      );
    });
  }

  // Related to add itinerary
  async createItinerary(): Promise<any> {
    this.loadingService.start();
    const { tourDates, isDatesOptional, noOfDays, currency} = this.tourForm.getRawValue();
    const daysInfo = [];
    const experienceInfo = [];

    if (!isDatesOptional){
      for (
        const date = moment(tourDates[0]);
        date.isSameOrBefore(tourDates[1]);
        date.add(1, "days")
      ) {
        daysInfo.push({
          date: date.toDate(),
          overviewDescription: "",
          destination: null,
          remarksTips: "",
          transport: []
        });
        experienceInfo.push({ date: date.toDate(), experiencesPerDay: [] });
      }
    }else{
      for (let i = 0; i < noOfDays; i++) {
        const date = moment().add(i, "days");
        daysInfo.push({
          date: date.toDate(),
          overviewDescription: "",
          destination: null,
          remarksTips: "",
          transport: []
        });
        experienceInfo.push({ date: date.toDate(), experiencesPerDay: [] });
      }
      // Set startDate and endDate in the form
      const startDate = daysInfo[0]?.date;
      const endDate = daysInfo[daysInfo.length - 1]?.date;
      this.tourForm.patchValue({
        startDate,
        endDate
      });

    }

    const { predefinedCosting } = this.brand;
    const additionalCosts = predefinedCosting
      .map(({ _id, ...rest }: any) => rest)
      .filter((preCost: any) => preCost.currency === currency || preCost.currency === null || preCost.currency === undefined);
    const costing = {
      additionalCosts
    };
    const tourValues = this.tourForm.getRawValue();
    if (tourValues.season) {
      tourValues.season = this.getSeasonById(tourValues.season);
    }
    const polices = await this.setOtherContent(tourValues.language);
    const payload: any = {
      tour: tourValues,
      itinerary: polices,
      title: "",
      days: daysInfo,
      accommodation: [],
      images: [],
      experiences: experienceInfo,
      costing,
    };

    // remove customer from the payload, customer needs ref avoid db error
    // only do this if payload.tour actually exists
    if (payload.tour) {
      ["customer", "agent", "selectedContact", "category"].forEach(key => {
        const v = payload.tour[key];

        // v == null is true for both undefined and null
        // check empty string, and the literal 'undefined'
        if (v == null || v === "" || v === "undefined" || v === undefined) {
          delete payload.tour[key];
        }
      });
    }

    try {
      const result: any = await this.activeService.createItinerary(payload);
      const other = await this.otherContentService.findAllOtherContent();

      if (other.length === 0) {
        await this.otherContentService.createOtherContent({
          exclusions: [],
          inclusions: [],
          policies: [],
        });
      }

      this.loadingService.stop();
      this.message.success(this.translocoService.translate("itineraries.addEditItinerary.messages.itineraryAdded"));
      this.location.replaceState("/");
      const editPath = this.mode === 'template' ? '/admin/template-itinerary/edit/' : '/admin/itineraries/edit/';
      if (this.isTour && (this.isAdd && this.rIti === null)) {
        this.router.navigate([editPath, result._id], {
          queryParams: { tour: true },
        });
      } else {
        this.router.navigate([editPath, result._id]);
      }
    } catch (e) {
      this.loadingService.stop();
      this.router.navigate(["/"]);
    }
  }

  // Related to add itinerary from template
  async createItineraryFromTemplate(): Promise<any> {
    this.loadingService.start();
    const { tourDates, isDatesOptional, noOfDays, currency} = this.tourForm.getRawValue();
    const daysInfo = [];
    const experienceInfo = [];

    // When creating from a template, carry over template's days, experiences, and accommodation
    const templateDays = this.singleItinerary.days || [];
    const templateExperiences = this.singleItinerary.experiences || [];

    if (!isDatesOptional) {
      let index = 0;
      for (
        const date = moment(tourDates[0]);
        date.isSameOrBefore(tourDates[1]);
        date.add(1, "days")
      ) {
        const templateDay = templateDays[index];
        const templateExp = templateExperiences[index];
        const strippedDay = this.stripTopLevelIds(templateDay || {});
        daysInfo.push({
          ...strippedDay,
          date: date.toDate(),
          overviewDescription: strippedDay.overviewDescription || "",
          destination: strippedDay.destination?._id || strippedDay.destination || null,
          remarksTips: strippedDay.remarksTips || "",
          transport: this.stripTopLevelIds(strippedDay.transport || []).map((t: any) => ({
            ...t,
            selectedDate: date.toDate(),
            selectedDateIndex: index,
          })),
        });
        experienceInfo.push({
          date: date.toDate(),
          experiencesPerDay: this.stripTopLevelIds(templateExp?.experiencesPerDay || []),
        });
        index++;
      }
    } else {
      for (let i = 0; i < noOfDays; i++) {
        const date = moment().add(i, "days");
        const templateDay = templateDays[i];
        const templateExp = templateExperiences[i];
        const strippedDay = this.stripTopLevelIds(templateDay || {});
        daysInfo.push({
          ...strippedDay,
          date: date.toDate(),
          overviewDescription: strippedDay.overviewDescription || "",
          destination: strippedDay.destination?._id || strippedDay.destination || null,
          remarksTips: strippedDay.remarksTips || "",
          transport: this.stripTopLevelIds(strippedDay.transport || []).map((t: any) => ({
            ...t,
            selectedDate: date.toDate(),
            selectedDateIndex: i,
          })),
        });
        experienceInfo.push({
          date: date.toDate(),
          experiencesPerDay: this.stripTopLevelIds(templateExp?.experiencesPerDay || []),
        });
      }
      // Set startDate and endDate in the form
      const startDate = daysInfo[0]?.date;
      const endDate = daysInfo[daysInfo.length - 1]?.date;
      this.tourForm.patchValue({
        startDate,
        endDate
      });
    }

    const strippedCosting = this.stripTopLevelIds(this.singleItinerary?.costing || {});
    const templateAdditionalCosts = this.stripTopLevelIds(strippedCosting.additionalCosts || [])
      .filter((preCost: any) => preCost.currency === currency || preCost.currency === null || preCost.currency === undefined);
    const costing = {
      ...strippedCosting,
      additionalCosts: templateAdditionalCosts,
    };

    const tourValues = this.tourForm.getRawValue();
    if (tourValues.season) {
      tourValues.season = this.getSeasonById(tourValues.season);
    }

    let polices = await this.setOtherContent(tourValues.language);
    // Use template's itinerary data (inclusions, exclusions, policies)
    if (this.singleItinerary?.itinerary) {
      polices = {
        inclusions: this.singleItinerary.itinerary.inclusions || polices.inclusions,
        exclusions: this.singleItinerary.itinerary.exclusions || polices.exclusions,
        policies: this.singleItinerary.itinerary.policies || polices.policies,
      };
    }

    // Carry over accommodation and images
    let templateAccommodation = this.stripTopLevelIds(this.singleItinerary.accommodation || []);
    const templateImages = this.singleItinerary.images || [];

    // Adjust accommodation dates to match the new tour dates
    if (!isDatesOptional && tourDates[0] && tourDates[1]) {
      const newStartDate = moment(tourDates[0]).startOf('day');
      const oldStartDate = moment(this.singleItinerary.tour?.startDate).startOf('day');
      const dateDiff = newStartDate.diff(oldStartDate, 'days');
      templateAccommodation = templateAccommodation.map((acc: any) => ({
        ...acc,
        checkIn: moment(acc.checkIn).add(dateDiff, 'days').format('YYYY-MM-DD'),
        checkOut: moment(acc.checkOut).add(dateDiff, 'days').format('YYYY-MM-DD'),
      }));
      // Remove accommodation entries that extend beyond the new end date
      const newEndDate = moment(tourDates[1]).startOf('day');
      templateAccommodation = templateAccommodation.filter((acc: any) =>
        moment(acc.checkIn).isSameOrBefore(newEndDate, 'day')
      );
    } else if (isDatesOptional) {
      const newStartDate = moment().startOf('day');
      const oldStartDate = moment(this.singleItinerary.tour?.startDate).startOf('day');
      const dateDiff = newStartDate.diff(oldStartDate, 'days');
      const newEndDate = moment(newStartDate).add(noOfDays - 1, 'days').startOf('day');
      templateAccommodation = templateAccommodation.map((acc: any) => ({
        ...acc,
        checkIn: moment(acc.checkIn).add(dateDiff, 'days').format('YYYY-MM-DD'),
        checkOut: moment(acc.checkOut).add(dateDiff, 'days').format('YYYY-MM-DD'),
      }));
      templateAccommodation = templateAccommodation.filter((acc: any) =>
        moment(acc.checkIn).isSameOrBefore(newEndDate, 'day')
      );
    }

    const payload: any = {
      tour: tourValues,
      itinerary: polices,
      title: this.singleItinerary?.title || "",
      days: daysInfo,
      accommodation: templateAccommodation,
      images: templateImages,
      experiences: experienceInfo,
      costing,
      featured: this.singleItinerary?.featured || {},
      viewSettings: this.singleItinerary?.viewSettings || {},
      costSettings: this.singleItinerary?.costSettings || {},
      paymentLink: this.singleItinerary?.paymentLink || '',
      remarks: this.singleItinerary?.remarks || '',
      excludePredefinedCost: this.singleItinerary?.excludePredefinedCost || false,
      isCreatedFromTemplate: true,
      templateTitle: this.singleItinerary?.title || '',
    };

    payload.viewSettings.isItineraryReferenceNumberChecked = true;

    // remove customer from the payload, customer needs ref avoid db error
    if (payload.tour) {
      ["customer", "agent", "selectedContact", "category"].forEach(key => {
        const v = payload.tour[key];
        if (v == null || v === "" || v === "undefined" || v === undefined) {
          delete payload.tour[key];
        }
      });
    }

    try {
      const result: any = await this.itineraryService.createItineraryFromTemplate(payload);
      const other = await this.otherContentService.findAllOtherContent();

      if (other.length === 0) {
        await this.otherContentService.createOtherContent({
          exclusions: [],
          inclusions: [],
          policies: [],
        });
      }

      this.loadingService.stop();
      this.message.success(this.translocoService.translate("itineraries.addEditItinerary.messages.itineraryAdded"));
      this.location.replaceState("/");
      this.router.navigate(['/admin/itineraries/edit', result._id]);
    } catch (e) {
      this.loadingService.stop();
      this.router.navigate(["/"]);
    }
  }

  copyLink(data: any): void {
    const theme = SETTINGS.THEME_TYPES_NAVI_B2C.find(theme => theme.value === data.tour.themeType);
    const params = new URLSearchParams({ rretMgxg: "nono" });
    const baseUrl = this.getHostnameUrl();
    this.clipboard.copy(`${baseUrl}${theme?.url}/${data._id}/${true}?${params.toString()}`);
    this.messageService.success(this.translocoService.translate("itineraries.messages.previewLinkCopied"));
  }

  async recentlyCurrencyAndLanguageGet(): Promise<any> {
    this.recentlyItinerary =
      await this.activeService.recentlyItineraryCurrencyAndLanguageGet();
  }

  async findBrand(): Promise<any> {
    const user = await this.authService.getLoggedInUser();
    const brand = await this.settingService.findBrand(user.userId);
    this.brand = brand;
    this.selectedLanguages = brand?.selectedLanguages || [];
  }

  get seasonCategory(): any[] {
    return this.brand?.seasonCategory || [];
  }

  getSeasonById(id: string): any {
    if (!id) return null;
    return this.seasonCategory.find((s: any) => s._id === id) || null;
  }

  async getLanguages(): Promise<any> {
    this.languages = await this.languageService.getContentLanguages();
  }

  getSelectedLanguagesObjectArray(): any {
    const arr: any = [];
    this.selectedLanguages?.forEach((lang: string) => {
      arr.push(this.languages?.find((l: any) => l.code === lang));
    });
    return arr;
  }

  findLanguageByCode(code: any): string {
    const langArray = this.languages;
    const selectedLang = langArray.find(
      (element: any) => element.code === code
    )?.name;

    if (!selectedLang) {
      return "-";
    }
    return selectedLang;
  }

  async getCurrencies(): Promise<any> {
    this.currencies = await this.currencyService.getCurrencies();
  }

  async getActiveCustomers(): Promise<any> {
    this.activeCustomers = await this.customerService.getAllActiveCustomers();
  }

  async getActiveAgents(): Promise<any> {
    try {
      this.activeAgents = await this.agentService.getAllActiveAgents();
    } catch (e: any) {
      this.message.error(e.error.message);
    }
  }

  async getActiveCategories(): Promise<any> {
    try {
      this.activeCategories = await this.categoryService.getAllActiveCategories();
    } catch (e: any) {
      this.message.error(e.error.message);
    }
  }


  // End of related to add itinerary
  setFeaturedContent(): void {
    const isSliderEnabled = this.singleItinerary?.featured?.isSliderEnabled ?? false;
    this.featuredForm.patchValue({
      description:
        this.singleItinerary?.featured?.description,
      image:
        this.singleItinerary?.featured?.image || this.images[0] || this.overviewImages[0],
      isSliderEnabled,
      sliderImages: isSliderEnabled ? (this.singleItinerary?.featured?.sliderImages || []) : [],
    });
    this.featuredForm.get('plaintextDescription')?.setValue(
      this.stripHtmlForMeta(this.singleItinerary?.featured?.description ?? ''),
      { emitEvent: false }
    );
  }

  setTitleContent(): void {
    this.titleForm.patchValue({
      title: this.singleItinerary?.title,
    });
  }

  setViewSettings(): void {
    this.tourOperatorBoxChecked = this.singleItinerary?.viewSettings.isTourOperatorHidden;
    this.costingBoxChecked = this.singleItinerary?.viewSettings?.isTourCostHidden;
    this.companyInformationBoxChecked = this.singleItinerary?.viewSettings?.isCompanyDetailsHidden;
    this.departureBoxChecked = this.singleItinerary?.viewSettings?.isDepartureChecked;
    this.mileageBoxChecked = this.singleItinerary?.viewSettings?.isMileageChecked;
    this.travelTimeBoxChecked = this.singleItinerary?.viewSettings?.isTravelTimeChecked;
    this.vehicleNameBoxChecked = this.singleItinerary?.viewSettings?.isVehicleNameChecked;
    this.vehicleImageBoxChecked = this.singleItinerary?.viewSettings?.isVehicleImageChecked ?? false;
    this.remarksTipsBoxChecked = this.singleItinerary?.viewSettings?.isRemarksTipsChecked;
    this.itineraryTitleBoxChecked = this.singleItinerary?.viewSettings?.isItineraryTitleChecked;
    this.itineraryReferenceNumberBoxChecked = this.singleItinerary?.viewSettings?.isItineraryReferenceNumberChecked ?? true;
    this.hotelRatingBoxChecked = this.singleItinerary?.viewSettings?.isHotelRatingChecked;
    this.hotelDescriptionBoxChecked = this.singleItinerary?.viewSettings?.isHotelDescriptionChecked;
    this.hotelWebsiteBoxChecked = this.singleItinerary?.viewSettings?.isHotelWebsiteChecked;
    this.hotelImageBoxChecked = this.singleItinerary?.viewSettings?.isHotelImageChecked;
    this.websiteLinkBoxChecked = this.singleItinerary?.viewSettings?.isWebsiteLinkChecked;
    this.paymentLinkBoxChecked = this.singleItinerary?.viewSettings?.isPaymentLinkChecked;
    this.customerInformationBoxChecked = this.singleItinerary?.viewSettings?.isCustomerInformationChecked;
    this.displayMapTopsideBoxChecked = this.singleItinerary?.viewSettings?.isDisplayMapTopsideChecked;
    this.thumbnailBoxChecked = this.singleItinerary?.viewSettings?.isThumbnailChecked ?? false;
    this.hideDaywiseInclusionsExclusionsBoxChecked = this.singleItinerary?.viewSettings?.isDaywiseInclusionsExclusionsChecked ?? false;
    this.includeBadgeBoxChecked = this.singleItinerary?.viewSettings?.isIncludeBadgeChecked ?? false;
    this.excludeBadgeBoxChecked = this.singleItinerary?.viewSettings?.isExcludeBadgeChecked ?? false;
    this.accommodationNoteBoxChecked = this.singleItinerary?.viewSettings?.isAccommodationNoteChecked ?? true;
    this.accommodationRoomsBoxChecked = this.singleItinerary?.viewSettings?.isAccommodationRoomsChecked ?? true;
    this.transportNoteBoxChecked = this.singleItinerary?.viewSettings?.isTransportNoteChecked ?? true;
    this.experiencesNoteBoxChecked = this.singleItinerary?.viewSettings?.isExperiencesNoteChecked ?? true;
    this.hideExperiencesTimesBoxChecked = this.singleItinerary?.viewSettings?.isExperiencesTimesChecked ?? false;
    this.pricingRemarksBoxChecked = this.singleItinerary?.viewSettings?.isPricingRemarksChecked ?? false;
    this.additionalNotesBoxChecked = this.singleItinerary?.viewSettings?.isAdditionalNotesChecked ?? false;
    this.mapType = this.singleItinerary?.viewSettings?.mapType || "NAV";
  }

  setCostSettings(): void {
    this.isSubTotalManual = this.singleItinerary?.costSettings?.isSubTotalManual || false;
    this.isDynamicPricing = this.singleItinerary?.costSettings?.isDynamicPricing || false;
    this.isSubTotalManual ? this.costingForm.get("totalCost").enable() :
      this.costingForm.get("totalCost").disable(); // disable totalCost field
  }

  setLinks(): void {
    this.paymentLink = this.singleItinerary?.paymentLink;
  }

  setRemarks(): void {
    this.remarks = this.singleItinerary?.remarks;
  }

  async setOtherContent(lang: any): Promise<any> {
    const other = await this.otherContentService.findAllOtherContent();
    const inc = other[0]?.inclusions.find((l: any) => l?.language === lang) || {};
    const exc = other[0]?.exclusions.find((l: any) => l?.language === lang) || {};
    const pol = other[0]?.policies.find((l: any) => l?.language === lang) || {};
    let content: any = {};
    content = {
      inclusions: this.singleItinerary?.itinerary?.inclusions || inc?.content || "",
      exclusions: this.singleItinerary?.itinerary?.exclusions || exc?.content || "",
      policies: this.singleItinerary?.itinerary?.policies || pol?.content || "",
    };
    return content;
  }

  reloadItinerary(): void {
    Promise.all([this.loadItineraryByID()]).then(async () => {
      this.cardLoading = false;
      this.setFeaturedContent();
      this.setTitleContent();
      this.setViewSettings();
      this.setCostSettings();
      this.newCalculateTotalCost();
      this.setLinks();
      this.setRemarks();

      this.themeType = this.singleItinerary?.tour.themeType;
      this.overviewDescription = this.singleItinerary.days[this.tabIndex].overviewDescription;
      this.remarksTips = this.singleItinerary.days[this.tabIndex]?.remarksTips || "";
      this.accommodations = getAccommodationPerDate(this.singleItinerary.days[this.tabIndex].date, this.singleItinerary.accommodation);
      this.originalPayload = _.cloneDeep(this.getCurrentUpdatePayload());
    });
  }

  async loadItineraryByID(): Promise<any> {
    this.cardLoading = true;
    try {
      this.singleItinerary = await this.activeService.getItineraryByIdLockState(this.withSession({
        id: this.rId,
      }));
      await this.findBrand();
      this.countrySequence();
      this.citySequence();
      this.overviewImages = await this.getOverviewImages(this.rId);
      const {
        tour: {
          pax: { children, adults },
        },
      } = this.singleItinerary;
      this.numOfPax = children + adults;
      this.toggleDayAdditionalCosts = this.singleItinerary.days.map(
        (day: any) => Array.isArray(day.additionalCosts) && day.additionalCosts.length > 0
      );
      this.toggleDayInclusionsExclusions = this.singleItinerary.days.map(
        (day: any) => (Array.isArray(day.inclusions) && day.inclusions.length > 0) || (Array.isArray(day.exclusions) && day.exclusions.length > 0)
      );
      this.singleItinerary.days.forEach((day: any) => {
        if (!Array.isArray(day.inclusions)) {
          day.inclusions = [];
        }
        if (!Array.isArray(day.exclusions)) {
          day.exclusions = [];
        }
      });
      this.images = this.singleItinerary?.images || [];
      this.fileList = this.images.map(
        (image: any, index: number) => ({
          uid: (index + 1).toString(),
          name: "image.png",
          status: "done",
          url: image,
        }));
      if (this.singleItinerary?.itinerary) {
        this.itineraryForm.patchValue(this.singleItinerary.itinerary);
      }
      this.setAdditionalNotesContent();
      if (this.singleItinerary.costing) {
        this.excludeCost = this.singleItinerary?.excludePredefinedCost || [];
        const { additionalCosts } = this.singleItinerary?.costing;
        this.costingForm.patchValue(this.singleItinerary?.costing);
        if (this.singleItinerary.costSettings.isDynamicPricing && (this.singleItinerary?.costing?.dynamicPricing?.headers?.length === 0
            || this.singleItinerary?.costing?.dynamicPricing === undefined )
        ) {
          this.defaultDynamicValues()
        }else {
          this.clearDymanicTable()
          this.addDynamicPricingData(
            this.singleItinerary?.costing?.dynamicPricing?.headers || [],
            this.singleItinerary?.costing?.dynamicPricing?.rows || []
          )
        }

        // empty the array when the function is called, does not duplicate the values
        this.clearAdditionalCosts();
        additionalCosts.forEach(({ title, cost, costCalSymbol, entryType, currency }: any) => {
              this.addAdditionalCost(title, cost, costCalSymbol, entryType, currency);}
        );
      }

      if (this.singleItinerary.lock === null || this.determineStatusLogic()) {
        this.titleForm.disable();
        this.costingForm.disable();
        this.itineraryForm.disable();
        this.additionalNotesForm.disable();
        this.featuredForm.disable();
      } else if (!this.singleItinerary.readOnly) {
        this.persistTabSessionId();
      }
      this.cardLoading = false;
    } catch (e: any) {
      this.cardLoading = false;
      console.log(e);
      this.messageService.error(e.error.message);
      this._location.back();
    }
  }

  async getOverviewImages(id: string): Promise<any> {
    try {

      return await this.itineraryService.getOverviewImagesItinerary(id);

    } catch (e) {
      this.message.error(this.translocoService.translate("itineraries.moveDeleteDays.messages.somethingWentWrong"));
    }
  }

  addAdditionalCost(title: string, cost: number, costCalSymbol: string, entryType: string, currency: string | null): void {
    this.getAdditionalCosts().push(
      this.fb.group({
        title: [title ? title : this.t("itineraries.costBreakdown.costing.titleColumn")],
        cost: [cost ? cost : 0],
        costCalSymbol: [costCalSymbol ? costCalSymbol : "PERCENT"],
        entryType: [entryType ? entryType : "TYPED"],
        currency: [currency === "" ? null : currency ],
      })
    );
  }

  getAdditionalCosts(): FormArray {
    return this.costingForm.get("additionalCosts");
  }

  clearAdditionalCosts(): void {
    this.getAdditionalCosts().clear();
  }

  clearDymanicTable(): void {
    this.rowsFA.clear();
    this.headersFA.clear();
  }

  getTabIndex(index: number): void {
    this.tabIndex = index;
  }

  isArrayEmpty(arr: any[]): boolean {
    return _.isEmpty(arr);
  }

  onTabChange({ index }: any): void {
    this.overviewDescription = this.singleItinerary.days[index].overviewDescription;
    this.remarksTips = this.singleItinerary.days[index]?.remarksTips || "";
    this.accommodations = getAccommodationPerDate(this.singleItinerary.days[index].date, this.singleItinerary.accommodation);

  }

  getFixedOrPercentageValue(
    symbol: string,
    totalCost: number,
    ratioCost: number
  ): number {
    let value = ratioCost ? ratioCost : 0;
    if (symbol === "PERCENT") {
      value = totalCost * (value / 100);
    }
    return value;
  }

  calculateTotalCost(): void {
    const totalCost =
      this.costingForm.get("transportation").get("totalCost").value +
      this.costingForm.get("accommodation").get("totalCost").value +
      this.costingForm.get("activities").get("totalCost").value;
    this.costingForm.patchValue({
      totalCost,
    });
  }

  async updateItineraryContent(isAuto?: boolean): Promise<any> {
    if (this.itinerarySaveInProgress) {
      return;
    }
    this.itinerarySaveInProgress = true;
    if (!isAuto) {
      this.cardLoading = true;
    }
    const costing = this.costingForm.getRawValue();
    const settings = {
      isTourCostHidden: this.costingBoxChecked,
      // isTourOperatorHidden: this.tourOperatorBoxChecked,
      // isCompanyDetailsHidden: this.companyInformationBoxChecked,
      isDepartureChecked: this.departureBoxChecked,
      isMileageChecked: this.mileageBoxChecked,
      isTravelTimeChecked: this.travelTimeBoxChecked,
      isVehicleNameChecked: this.vehicleNameBoxChecked,
      isVehicleImageChecked: this.vehicleImageBoxChecked,
      isRemarksTipsChecked: this.remarksTipsBoxChecked,
      isItineraryTitleChecked: this.itineraryTitleBoxChecked,
      isItineraryReferenceNumberChecked: this.itineraryReferenceNumberBoxChecked,
      isHotelRatingChecked: this.hotelRatingBoxChecked,
      isHotelDescriptionChecked: this.hotelDescriptionBoxChecked,
      isHotelWebsiteChecked: this.hotelWebsiteBoxChecked,
      isHotelImageChecked: this.hotelImageBoxChecked,
      isWebsiteLinkChecked: this.websiteLinkBoxChecked,
      isPaymentLinkChecked: this.paymentLinkBoxChecked,
      isCustomerInformationChecked: this.customerInformationBoxChecked,
      isDisplayMapTopsideChecked: this.displayMapTopsideBoxChecked,
      isThumbnailChecked: this.thumbnailBoxChecked,
      isDaywiseInclusionsExclusionsChecked: this.hideDaywiseInclusionsExclusionsBoxChecked,
      isIncludeBadgeChecked: this.includeBadgeBoxChecked,
      isExcludeBadgeChecked: this.excludeBadgeBoxChecked,
      isAccommodationNoteChecked: this.accommodationNoteBoxChecked,
      isAccommodationRoomsChecked: this.accommodationRoomsBoxChecked,
      isTransportNoteChecked: this.transportNoteBoxChecked,
      isExperiencesNoteChecked: this.experiencesNoteBoxChecked,
      isExperiencesTimesChecked: this.hideExperiencesTimesBoxChecked,
      isPricingRemarksChecked: this.pricingRemarksBoxChecked,
      isAdditionalNotesChecked: this.additionalNotesBoxChecked,
      mapType: this.mapType

    };
    const cSettings = {
      isSubTotalManual: this.isSubTotalManual,
      isDynamicPricing: this.isDynamicPricing,
    };
    const updatePayload = {
      featured: this.featuredForm.getRawValue(),
      itinerary: this.itineraryForm.getRawValue(),
      ...this.titleForm.getRawValue(),
      days: this.singleItinerary.days,
      costing,
      viewSettings: settings,
      costSettings: cSettings,
      paymentLink: this.paymentLink,
      remarks: this.remarks,
      additionalNotes: this.buildAdditionalNotesPayload(),
      excludePredefinedCost: this.excludeCost
    };

    try {
      const itinerary = await this.activeService.updateItineraryLockState(this.withSession({
        _id: this.singleItinerary._id,
        ...updatePayload,
      }));
      this.originalPayload = _.cloneDeep(updatePayload);
      this.messageService.success(this.translocoService.translate("itineraries.addEditItinerary.messages.itinerarySaved"));
      this.updatedTime = itinerary.updatedAt;
      this.cardLoading = false;
    } catch (e: any) {
      this.message.error(e?.message?.message ?? e?.message ?? e);
    } finally {
      this.itinerarySaveInProgress = false;
    }
  }

  async autoUpdateItineraryContent(isAuto?: boolean): Promise<any> {
    if (this.itinerarySaveInProgress) {
      return;
    }
    this.itinerarySaveInProgress = true;
   const firstMessage = this.messageService.success(this.translocoService.translate("itineraries.addEditItinerary.messages.savingItinerary"), { nzDuration: 0 });
    if (!isAuto) {
      this.cardLoading = true;
    }
    const costing = this.costingForm.getRawValue();
    const settings = {
      isTourCostHidden: this.costingBoxChecked,
      // isTourOperatorHidden: this.tourOperatorBoxChecked,
      // isCompanyDetailsHidden: this.companyInformationBoxChecked,
      isDepartureChecked: this.departureBoxChecked,
      isMileageChecked: this.mileageBoxChecked,
      isTravelTimeChecked: this.travelTimeBoxChecked,
      isVehicleNameChecked: this.vehicleNameBoxChecked,
      isVehicleImageChecked: this.vehicleImageBoxChecked,
      isRemarksTipsChecked: this.remarksTipsBoxChecked,
      isItineraryTitleChecked: this.itineraryTitleBoxChecked,
      isItineraryReferenceNumberChecked: this.itineraryReferenceNumberBoxChecked,
      isHotelRatingChecked: this.hotelRatingBoxChecked,
      isHotelDescriptionChecked: this.hotelDescriptionBoxChecked,
      isHotelWebsiteChecked: this.hotelWebsiteBoxChecked,
      isHotelImageChecked: this.hotelImageBoxChecked,
      isWebsiteLinkChecked: this.websiteLinkBoxChecked,
      isPaymentLinkChecked: this.paymentLinkBoxChecked,
      isCustomerInformationChecked: this.customerInformationBoxChecked,
      isDisplayMapTopsideChecked: this.displayMapTopsideBoxChecked,
      isThumbnailChecked: this.thumbnailBoxChecked,
      isDaywiseInclusionsExclusionsChecked: this.hideDaywiseInclusionsExclusionsBoxChecked,
      isIncludeBadgeChecked: this.includeBadgeBoxChecked,
      isExcludeBadgeChecked: this.excludeBadgeBoxChecked,
      isAccommodationNoteChecked: this.accommodationNoteBoxChecked,
      isAccommodationRoomsChecked: this.accommodationRoomsBoxChecked,
      isTransportNoteChecked: this.transportNoteBoxChecked,
      isExperiencesNoteChecked: this.experiencesNoteBoxChecked,
      isExperiencesTimesChecked: this.hideExperiencesTimesBoxChecked,
      isPricingRemarksChecked: this.pricingRemarksBoxChecked,
      isAdditionalNotesChecked: this.additionalNotesBoxChecked,
      mapType: this.mapType

    };
    const cSettings = {
      isSubTotalManual: this.isSubTotalManual,
      isDynamicPricing: this.isDynamicPricing,
    };
   const updatePayload = {
      featured: this.featuredForm.getRawValue(),
      itinerary: this.itineraryForm.getRawValue(),
      ...this.titleForm.getRawValue(),
      days: this.singleItinerary.days,
      costing,
      viewSettings: settings,
      costSettings: cSettings,
      paymentLink: this.paymentLink,
      remarks: this.remarks,
      additionalNotes: this.buildAdditionalNotesPayload(),
      excludePredefinedCost: this.excludeCost
    };

   try {
      const itinerary = await this.activeService.updateItineraryLockState(this.withSession({
        _id: this.singleItinerary._id,
        ...updatePayload,
      }));
      this.messageService.remove(firstMessage.messageId);
      this.originalPayload = _.cloneDeep(updatePayload);
      this.messageService.success(this.translocoService.translate("itineraries.addEditItinerary.messages.itineraryUpdatedSuccessfully"));
      this.updatedTime = itinerary.updatedAt;
      this.cardLoading = false;
    } catch (e: any) {
      this.messageService.remove(firstMessage.messageId);
      this.message.error(this.translocoService.translate("itineraries.addEditItinerary.messages.failedToSaveItinerary", {
        error: e.message.message
      }));
      this.cardLoading = false;
    } finally {
      this.itinerarySaveInProgress = false;
    }
  }

  async extendLockState(): Promise<void> {

    try {
      await this.activeService.extendLockState(this.withSession({
        _id: this.singleItinerary._id,
      }));
    } catch (e: any) {
      console.log(e?.message?.message || e);
    }
  }

  async updateLeisureDay(): Promise<any> {
    const costing = this.costingForm.getRawValue();
    const settings = {
      isTourCostHidden: this.costingBoxChecked,
      // isTourOperatorHidden: this.tourOperatorBoxChecked,
      // isCompanyDetailsHidden: this.companyInformationBoxChecked,
      isDepartureChecked: this.departureBoxChecked,
      isMileageChecked: this.mileageBoxChecked,
      isTravelTimeChecked: this.travelTimeBoxChecked,
      isVehicleNameChecked: this.vehicleNameBoxChecked,
      isVehicleImageChecked: this.vehicleImageBoxChecked,
      isRemarksTipsChecked: this.remarksTipsBoxChecked,
      isItineraryTitleChecked: this.itineraryTitleBoxChecked,
      isItineraryReferenceNumberChecked: this.itineraryReferenceNumberBoxChecked,
      isHotelRatingChecked: this.hotelRatingBoxChecked,
      isHotelDescriptionChecked: this.hotelDescriptionBoxChecked,
      isHotelWebsiteChecked: this.hotelWebsiteBoxChecked,
      isHotelImageChecked: this.hotelImageBoxChecked,
      isWebsiteLinkChecked: this.websiteLinkBoxChecked,
      isPaymentLinkChecked: this.paymentLinkBoxChecked,
      isCustomerInformationChecked: this.customerInformationBoxChecked,
      isDisplayMapTopsideChecked: this.displayMapTopsideBoxChecked,
      isThumbnailChecked: this.thumbnailBoxChecked,
      isDaywiseInclusionsExclusionsChecked: this.hideDaywiseInclusionsExclusionsBoxChecked,
      isIncludeBadgeChecked: this.includeBadgeBoxChecked,
      isExcludeBadgeChecked: this.excludeBadgeBoxChecked,
      isAccommodationNoteChecked: this.accommodationNoteBoxChecked,
      isAccommodationRoomsChecked: this.accommodationRoomsBoxChecked,
      isTransportNoteChecked: this.transportNoteBoxChecked,
      isExperiencesNoteChecked: this.experiencesNoteBoxChecked,
      isExperiencesTimesChecked: this.hideExperiencesTimesBoxChecked,
      isPricingRemarksChecked: this.pricingRemarksBoxChecked,
      isAdditionalNotesChecked: this.additionalNotesBoxChecked,
      mapType: this.mapType

    };
    const cSettings = {
      isSubTotalManual: this.isSubTotalManual,
      isDynamicPricing: this.isDynamicPricing,
    };
    const updatePayload = {
      featured: this.featuredForm.getRawValue(),
      itinerary: this.itineraryForm.getRawValue(),
      ...this.titleForm.getRawValue(),
      days: this.singleItinerary.days,
      costing,
      viewSettings: settings,
      costSettings: cSettings,
      paymentLink: this.paymentLink,
      remarks: this.remarks,
      additionalNotes: this.buildAdditionalNotesPayload(),
      excludePredefinedCost: this.excludeCost
    };

    try {
      const itinerary = await this.activeService.updateItineraryLockState(this.withSession({
        _id: this.singleItinerary._id,
        ...updatePayload,
      }));
      this.originalPayload = _.cloneDeep(updatePayload);
      this.updatedTime = itinerary.updatedAt;
    } catch (e: any) {
      this.message.error(e.message.message);
    }
  }


  async updateItineraryTourInformation(isAuto?: boolean): Promise<void> {

    this.loadingService.start();
    const tourData = this.tourForm.getRawValue();
    if (tourData.season) {
      tourData.season = this.getSeasonById(tourData.season);
    }
    const modifiedTourInformation = this.itineraryContentModification(tourData.noOfDays);

    let updatePayload: any;
    if (!tourData.isDatesOptional) {
      updatePayload = {
        ...modifiedTourInformation,
        tour: tourData
      };
    }else{

      const startDate = modifiedTourInformation.days[0].date;
      const endDate = modifiedTourInformation.days[tourData.noOfDays - 1].date;
      updatePayload = {
        ...modifiedTourInformation,
        tour: {...tourData, startDate, endDate},
      };
    }

    // remove customer from the payload, customer needs ref avoid db error
    if (updatePayload.tour.customer === "") {
      delete updatePayload.tour.customer;
    }
    if (updatePayload.tour.category === "") {
      delete updatePayload.tour.category;
    }
    if (updatePayload.tour.agent === "") {
      delete updatePayload.tour.agent;
    }
    if (updatePayload.tour.selectedContact === "") {
      delete updatePayload.tour.selectedContact;
    }

    try {
      await this.activeService.updateItinerary({
        _id: this.singleItinerary._id,
        ...updatePayload,
      });

      this.loadingService.stop();
      const editPath = this.mode === 'template' ? '/admin/template-itinerary/edit/' : '/admin/itineraries/edit/';
      await this.router.navigate([editPath, this.singleItinerary._id]);

    } catch (e) {
      this.loadingService.stop();
      this.message.error(this.translocoService.translate("itineraries.addEditItinerary.messages.itineraryDidNotUpdate"));
      const listPath = this.mode === 'template' ? '/admin/template-itinerary' : '/admin/itineraries';
      await this.router.navigate([listPath]);
    }
  }

  itineraryContentModification(newAmountDays: number): any {
    const { tourDates, isDatesOptional, noOfDays} = this.tourForm.getRawValue();
    const daysInfo = [];
    const experienceInfo = [];
    let index = 0;

    if (!isDatesOptional) {
      for (
        const date = moment(tourDates[0]);
        date.isSameOrBefore(tourDates[1]);
        date.add(1, "days")
      ) {

        // change days to new date
        const day = this.singleItinerary.days[index];
        daysInfo.push({
          ...(day || {}),
          date: date.toDate(),
          destination: day?.destination?._id || null,
          transport: day?.transport || [],
        });

        // change experiences to new date
        experienceInfo.push({
          date: date.toDate(),
          experiencesPerDay: this.singleItinerary.experiences[index]?.experiencesPerDay || []
        });

        // change experiences  to new date
        for (let i = 0; i < daysInfo[index].transport.length; i++) {
          daysInfo[index].transport[i].selectedDate = date.toDate();
          daysInfo[index].transport[i].selectedDateIndex = index;
        }

        index++;
      }
    }else{
      for (let i = 0; i < noOfDays; i++) {
        const date = moment().add(i, "days");

        // change days to new date
        const day = this.singleItinerary.days[index];
        daysInfo.push({
          ...(day || {}),
          date: date.toDate(),
          destination: day?.destination?._id || null,
          transport: day?.transport || [],
        });

        // change experiences to new date
        experienceInfo.push({
          date: date.toDate(),
          experiencesPerDay: this.singleItinerary.experiences[index]?.experiencesPerDay || []
        });
        // change experiences  to new date
        for (let i = 0; i < daysInfo[index].transport.length; i++) {
          daysInfo[index].transport[i].selectedDate = date.toDate();
          daysInfo[index].transport[i].selectedDateIndex = index;
        }

        index++;
      }
    }

    const accommodation = this.accommodationModification();

    return {
      days: daysInfo,
      experiences: experienceInfo,
      accommodation
    };
  }

  accommodationModification(): any {
    const accommodation = this.singleItinerary.accommodation;
    const {tourDates, isDatesOptional, noOfDays} = this.tourForm.getRawValue();
    if (!isDatesOptional) {
      const oldStartDate = moment(this.singleItinerary.tour.startDate).startOf("day");
      const oldEndDate   = moment(this.singleItinerary.tour.endDate).startOf("day");
      for (
        const date = oldStartDate.clone();
        date.isSameOrBefore(oldEndDate);
        date.add(1, "days")
      ) {
        accommodation.forEach((acc: any, accIndex: number) => {
          const checkInDate  = moment(acc.checkIn).startOf("day");
          const checkOutDate = moment(acc.checkOut).startOf("day");
          if (checkInDate.isSame(date, "day")) {
            // difference relative to old start date
            const checkInDiff = checkInDate.diff(oldStartDate, "days");

            // stay length
            const stayNights = checkOutDate.diff(checkInDate, "days");

            // new check-in and check-out in string format
            acc.checkIn = moment(tourDates[0])
              .add(checkInDiff, "days")
              .format("YYYY-MM-DD");

            acc.checkOut = moment(tourDates[0])
              .add(checkInDiff + stayNights, "days")
              .format("YYYY-MM-DD");

            if (moment(tourDates[1]).isBefore(moment(acc.checkOut))) {
              accommodation.splice(accIndex, 1);
            }
          }
        });
      }
    } else {
      const days = this.singleItinerary.days ?? [];
      const oldStartDate = moment(days[0]?.date ?? this.singleItinerary.tour.startDate).startOf("day");
      const oldEndDate   = moment(days[days.length - 1]?.date ?? this.singleItinerary.tour.endDate).startOf("day");
      const startDate = moment().startOf("day");
      const endDate   = moment(startDate).add(noOfDays - 1, "days").startOf("day");
      for (const date = oldStartDate.clone(); date.isSameOrBefore(oldEndDate); date.add(1, "days")) {

        for (let accIndex = accommodation.length - 1; accIndex >= 0; accIndex--) {
          const acc = accommodation[accIndex];

          const checkInDate  = moment(acc.checkIn).startOf("day");
          const checkOutDate = moment(acc.checkOut).startOf("day");

          if (checkInDate.isSame(date, "day")) {
            const checkInDiff = checkInDate.diff(oldStartDate, "days");
            const stayNights  = checkOutDate.diff(checkInDate, "days");

            // string format outputs
            const newCheckIn  = moment(startDate)
              .add(checkInDiff, "days")
              .startOf("day")
              .format("YYYY-MM-DD");

            const newCheckOut = moment(startDate)
              .add(checkInDiff + stayNights, "days")
              .startOf("day")
              .format("YYYY-MM-DD");

            acc.checkIn  = newCheckIn;
            acc.checkOut = newCheckOut;

            if (endDate.isBefore(moment(newCheckOut))) {
              accommodation.splice(accIndex, 1);
            }
          }
        }
      }
    }
    return accommodation;
  }

  getTimeAgo(date: Date): string {
    return moment(date).fromNow();
  }

  ngOnDestroy(): void {
    this.langChangeSub?.unsubscribe();
    this.idleSub?.unsubscribe();
    this.pollSub?.unsubscribe();
    this.extendSub?.unsubscribe();
    clearInterval(this.autoUpdateInterval);

    if (this.addItineraryTour) {
      this.addItineraryTour.destroy();
    }

    if  (this.editItineraryTour) {
      this.editItineraryTour.destroy();
    }
  }

  sortOrderCurrency(list: any[]): any {
    return list.sort((a, b): any => {
      return a.cc.localeCompare(b.cc);
    });
  }

  orderByName(list: any[]): any {
    return AppUtils.sortOrderByName(list);
  }

  sortOrderByCustomerName(list: any[]): any {
    return list.sort((a, b): any => {
      return (a.first_name + " " + a.last_name).localeCompare(
        b.first_name + " " + b.last_name
      );
    });
  }

  // image handle for featured section
  setMediaUploadHeaders = (file: any) => {
    return {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
    };
  }

  handlePreview = async (file: NzUploadFile | any): Promise<void> => {
    if (!file.url && !file.preview) {
      // tslint:disable-next-line:no-non-null-assertion
      file.preview = await getBase64(file.originFileObj!);
    }
    this.previewImage = file.url || file.preview;
    this.previewVisible = true;
  }

  customUploadReq = (item: NzUploadXHRArgs | any) => {
    this.loadingService.start();
    const formData = new FormData();
    formData.append("file", item.file);
    return this.uploadService.uploadFile(formData, item);
  }

  handleChange(event: NzUploadChangeParam): any {
    if (event && event.type === "success" && event.file.response?.url) {
      const url = event.file.response.url;
      if (!this.images.includes(url)) {
        this.images.push(url);
      }

      // Check if every file in the batch has finished (done or error).
      // Only then do a single save, so concurrent uploads don't race-overwrite each other.
      const allDone = event.fileList.every(
        (f) => f.status === 'done' || f.status === 'error'
      );

      if (allDone) {
        // Merge any remaining successful URLs from the fileList that may have
        // arrived out of order before this handler ran for them.
        event.fileList
          .filter((f) => f.status === 'done' && f.response?.url)
          .forEach((f) => {
            if (!this.images.includes(f.response.url)) {
              this.images.push(f.response.url);
            }
          });

        this.activeService.updateItineraryLockState(this.withSession({
          _id: this.singleItinerary._id,
          images: this.images
        })).then();
      }
    }
  }

  onRemove = (item: NzUploadXHRArgs | any) => {
    this.featuredImage = [];
    this.featuredForm.patchValue({
      image: ""
    });
    this.activeService.updateItineraryLockState(this.withSession(this.featuredForm.getRawValue())).then();
    return true;
  }

  addEditDestinationContent(itinerary: any, dateIndex: any, mode: string, destinationPlaceIDOrID: any, featuredContent: any, indexDay: number, entryType: string): void {
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate("itineraries.actions.destination"),
        nzWidth: "600px",
        nzContent: AddEditDestinationContentComponent,
        nzFooter: null,
        nzComponentParams: {
          itinerary,
          dateIndex,
          mode,
          destinationPlaceIDOrID,
          featuredContent,
          indexDay,
          entryType,
          itineraryMode: this.mode,
          sessionId: this.tabSessionId,
        },
      })
      .afterClose.subscribe(data => {
        if (data !== undefined) {
          data = mode === this.SETTINGS.ITINERARY_CONTENT_MODE.NEW ?
            this.SETTINGS.ITINERARY_MESSAGE_STATUS.ADD_SUCCESS :
            this.SETTINGS.ITINERARY_MESSAGE_STATUS.EDIT_SUCCESS;

          this.messagePopUp(
            data,
            this.translocoService.translate("itineraries.addEditItinerary.messages.somethingWentWrong"),
            this.translocoService.translate("itineraries.addEditItinerary.messages.destinationAdded"),
            this.translocoService.translate("itineraries.addEditItinerary.messages.destinationUpdated"),
          );
          this.reloadItinerary();
        }
      });
  }

  viewDestinationContent(itinerary: any, day: any): void {
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate("itineraries.actions.viewDestination"),
        nzWidth: "700px",
        nzContent: ViewDestinationContentComponent,
        nzFooter: null,
        nzComponentParams: {
          itinerary,
          day
        },
      })
      .afterClose.subscribe(data => {

      });
  }

  addEditAccommodationsContent(itinerary: any, mode: string, accommodationId: any, country: string): void {
    const vatPercentage = this.brand?.accVatPercentage ?? 0;
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate("itineraries.actions.accommodation"),
        nzWidth: "800px",
        nzContent: AddEditAccommodationContentComponent,
        nzFooter: null,
        nzComponentParams: {
          itinerary,
          mode,
          accommodationId,
          country,
          vatPercentage,
          itineraryMode: this.mode,
          sessionId: this.tabSessionId,
        },
      })
      .afterClose.subscribe(data => {
        console.log(data);
        if (data !== undefined) {
          this.messagePopUp(
            data,
            this.translocoService.translate("itineraries.addEditItinerary.messages.somethingWentWrong"),
            this.translocoService.translate("itineraries.addEditItinerary.messages.accommodationAdded"),
            this.translocoService.translate("itineraries.addEditItinerary.messages.accommodationUpdated")
          );
          this.reloadItinerary();
        }
      });
  }

  viewAccommodationContent(accommodation: any, currency: string, pax: any, secondaryCurrency: string, exchangeRate: number, itinerary: any): void {
    const vatPercentage = this.brand?.accVatPercentage ?? 0;
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate("itineraries.actions.viewAccommodation"),
        nzWidth: "700px",
        nzContent: ViewAccommodationContentComponent,
        nzFooter: null,
        nzComponentParams: {
          accommodation,
          currency,
          pax,
          secondaryCurrency,
          exchangeRate,
          itinerary,
          vatPercentage
        },
      })
      .afterClose.subscribe(data => {
      });
  }

  addEditTransportContent(itinerary: any, mode: string, transportIndex: number | null, dayIndex: number | null, country: string): void {
    const transportConfig = this.brand.transportCostingConfig;
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate("itineraries.actions.transport"),
        nzWidth: "700px",
        nzContent: AddEditTransportContentComponent,
        nzFooter: null,
        nzComponentParams: {
          itinerary,
          mode,
          transportIndex,
          dayIndex,
          country,
          transportConfig,
          itineraryMode: this.mode,
          sessionId: this.tabSessionId,
        },
      })
      .afterClose.subscribe(data => {
        if (data !== undefined) {
          this.messagePopUp(
            data,
            this.translocoService.translate("itineraries.addEditItinerary.messages.somethingWentWrong"),
            this.translocoService.translate("itineraries.addEditItinerary.messages.transportAdded"),
            this.translocoService.translate("itineraries.addEditItinerary.messages.transportUpdated")
          );
          this.reloadItinerary();
        }
      });
  }

  viewTransportContent(transport: any, currency: string, pax: any, secondaryCurrency: string, exchangeRate: number, itinerary: any): void {
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate("itineraries.actions.viewTransport"),
        nzContent: ViewTransportContentComponent,
        nzFooter: null,
        nzComponentParams: {
          transport,
          currency,
          pax,
          secondaryCurrency,
          exchangeRate,
          itinerary
        },
      })
      .afterClose.subscribe(data => {
      });
  }

  addEditExperiencesContent(itinerary: any, dateIndex: any, mode: string, experiencesPlaceIDOrID: any, entryType: string, featuredContent: any, featuredNote: string, country: string, indexDay: number, indexExperience: number): void {
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate("itineraries.actions.experiences"),
        nzWidth: "660px",
        nzContent: AddEditExperiencesContentComponent,
        nzFooter: null,
        nzComponentParams: {
          itinerary,
          dateIndex,
          mode,
          experiencesPlaceIDOrID,
          entryType,
          featuredContent,
          featuredNote,
          country,
          indexDay,
          indexExperience,
          itineraryMode: this.mode,
          sessionId: this.tabSessionId,
        },
      })
      .afterClose.subscribe(data => {
        if (data !== undefined) {
          data = mode === this.SETTINGS.ITINERARY_CONTENT_MODE.NEW ?
            this.SETTINGS.ITINERARY_MESSAGE_STATUS.ADD_SUCCESS :
            this.SETTINGS.ITINERARY_MESSAGE_STATUS.EDIT_SUCCESS;

          this.messagePopUp(
            data,
            this.translocoService.translate("itineraries.addEditItinerary.messages.somethingWentWrong"),
            this.translocoService.translate("itineraries.addEditItinerary.messages.experiencesAdded"),
            this.translocoService.translate("itineraries.addEditItinerary.messages.experiencesUpdated")
          );
          this.reloadItinerary();
        }
      });
  }

  viewExperiencesContent(itinerary: any, experience: any): void {
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate("itineraries.actions.viewExperience"),
        nzWidth: "700px",
        nzContent: ViewExperiencesContentComponent,
        nzFooter: null,
        nzComponentParams: {
          itinerary,
          experience
        },
      })
      .afterClose.subscribe(data => {
      });
  }

  // TODO check the name late due conflicting method names
  newCalculateTotalCost(): void {
    let cost = 0;
    const amountOfAdult = this.singleItinerary.tour.pax.adults;
    const amountOfChildren = this.singleItinerary.tour.pax.children;
    const amountOfInfant = this.singleItinerary.tour.pax.infants;
    let totalTransport = 0;
    let totalExperiences = 0;
    let totalAccommodation = 0;

    // Iterate over experiences
    this.singleItinerary.experiences.forEach((day: any, idx: number) => {
      if (!this.singleItinerary.days[idx].isLeisureDay) {
        day.experiencesPerDay.forEach((experience: any) => {
          if (experience.conditionType !== 'EXC') {
            const costType = experience?.costType ?? 'perPerson';

            if (costType === 'free') {
            } else if (costType === 'perGroup') {
              const groupTotal = experience?.costing?.totalCost || 0;
              if (!experience?.isPrimaryCurrency) {
                totalExperiences += groupTotal / (this.singleItinerary?.tour?.exchangeRate || 1);
              } else {
                totalExperiences += groupTotal;
              }
            } else {
              const personTotal = experience?.costing?.totalCost
                ? experience.costing.totalCost
                : ((experience?.costPerAdult || 0) * amountOfAdult) +
                  ((experience?.costPerChild || 0) * amountOfChildren) +
                  ((experience?.costPerInfant || 0) * amountOfInfant);
              if (!experience?.isPrimaryCurrency) {
                totalExperiences += personTotal / (this.singleItinerary?.tour?.exchangeRate || 1);
              } else {
                totalExperiences += personTotal;
              }
            }
          }
        });
      }
    });

    cost += totalExperiences;

    this.singleItinerary.days.forEach((day: any) => {
      // Iterate over accommodation
      if (!day.isLeisureDay) {
        this.singleItinerary.accommodation.forEach((accommodation: any) => {
          if (isDateInRange(day.date, accommodation.checkIn, accommodation.checkOut)) {
            if (!accommodation?.isPrimaryCurrency) {
              totalAccommodation += (accommodation?.totalCost / this.singleItinerary?.tour?.exchangeRate || 0);
            } else {
              totalAccommodation += (accommodation?.totalCost || 0);
            }
          }
        });
      }

      // Iterate over transport
      day.transport.forEach((transport: any) => {
        if (!transport?.isPrimaryCurrency){
          totalTransport += (transport.totalCost / this.singleItinerary?.tour?.exchangeRate);
        }else{
          totalTransport += transport.totalCost;
        }
      });
    });
    cost += totalAccommodation;
    cost += totalTransport;

    let totalDayAdditionalCosts = 0;
    this.singleItinerary.days.forEach((day: any) => {
      if (day.additionalCosts && Array.isArray(day.additionalCosts)) {
        day.additionalCosts.forEach((ac: any) => {
          totalDayAdditionalCosts += (ac.cost || 0);
        });
      }
    });
    cost += totalDayAdditionalCosts;
    // when the isSubTotal is false only, costing is calculated
    if (!this.isSubTotalManual) {
      this.costingForm.patchValue({
        totalCost: cost,
        totalExperiences,
        totalAccommodation,
        totalTransport
      });
    }
  }

  addOverviewDescriptionOnChange(event: any, index: number): void {
    this.overviewDescription = event;
    this.singleItinerary.days[index].overviewDescription = this.overviewDescription;
  }

  remarksTipsQuillModules = {
    clipboard: {
      matchVisual: false,
    },
  };

  onRemarksTipsEditorCreated(quill: any): void {
    const Delta = Quill.import('delta');
    const allowedAttributes = ['bold', 'italic', 'list', 'link'];

    quill.clipboard.addMatcher(Node.ELEMENT_NODE, (_node: Node, delta: any) => {
      const ops = (delta.ops ?? []).reduce((acc: any[], op: any) => {
        if (!op.insert || typeof op.insert !== 'string') {
          return acc;
        }
        if (!op.attributes) {
          acc.push({ insert: op.insert });
          return acc;
        }
        const attributes: Record<string, unknown> = {};
        for (const key of allowedAttributes) {
          if (op.attributes[key] != null) {
            attributes[key] = op.attributes[key];
          }
        }
        acc.push(
          Object.keys(attributes).length > 0
            ? { insert: op.insert, attributes }
            : { insert: op.insert }
        );
        return acc;
      }, []);
      return new Delta(ops);
    });
  }

  remarksTipsOnChange(event: any, index: number): void {
    this.remarksTips = event;
    this.singleItinerary.days[index].remarksTips = this.remarksTips;
  }
  remarksItineraryOnChange(event: any): void {
    this.remarks = event;
  }

  paymentLinkOnChange(event: string): void {
    this.isValidUrl = this.isUrlValid(event);
    if (this.isValidUrl) {
      this.paymentLink = event;
    } else {
      this.paymentLink = "";
    }
  }

  isUrlValid(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  }

  private stripHtmlForMeta(html: string): string {
    return html
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/<\/p>/gi, ' ')
      .replace(/<p[^>]*>/gi, '')
      .replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/gi, ' ')
      .replace(/&amp;/gi, '&')
      .replace(/&#39;/gi, "'")
      .replace(/&quot;/gi, '"')
      .replace(/\s+/g, ' ')
      .trim();
  }

  cancel(): void {
  }


  async onConfirmDeleteDestination(index: number, itinerary: any): Promise<any> {
    this.loadingService.start();
    try {
      itinerary.days
        .filter((day: any) => day.destination)
        .map((day: any) => {
          day.destination = day.destination._id ? day.destination._id : null;
          return day;
        });

      itinerary.days[index].destination = null;
      delete itinerary.days[index].featuredDestination;
      delete itinerary.days[index].standaloneImages;

      itinerary.days = destinationMergeChecker(itinerary.days);

      await this.activeService.updateItineraryLockState(this.withSession({ _id: this.singleItinerary._id, days: itinerary.days }));
      this.messagePopUp(
        "success",
        this.translocoService.translate("itineraries.addEditItinerary.messages.somethingWentWrong"),
        this.translocoService.translate("itineraries.addEditItinerary.messages.destinationDeleted")
      );
      this.reloadItinerary();

    } catch (e) {
      this.messagePopUp(
        "error",
        this.translocoService.translate("itineraries.addEditItinerary.messages.somethingWentWrong"),
        this.translocoService.translate("itineraries.addEditItinerary.messages.destinationDeleted")
      );
    }
    this.loadingService.stop();
  }

  async onConfirmDeleteAccommodation(id: string, info: any): Promise<any> {
    this.loadingService.start();
    try {
      info.accommodation = info.accommodation
        .filter((accommodate: any) => accommodate._id !== id);

      await this.activeService.updateItineraryLockState(this.withSession({ _id: this.singleItinerary._id, accommodation: info.accommodation }));
      this.messagePopUp(
        "success",
        this.translocoService.translate("itineraries.addEditItinerary.messages.somethingWentWrong"),
        this.translocoService.translate("itineraries.addEditItinerary.messages.accommodationDeleted")
      );
      this.reloadItinerary();

    } catch (e) {
      this.messagePopUp(
        "error",
        this.translocoService.translate("itineraries.addEditItinerary.messages.somethingWentWrong"),
        this.translocoService.translate("itineraries.addEditItinerary.messages.accommodationDeleted")
      );
    }
    this.loadingService.stop();
  }

  async onConfirmDeleteTransport(daysIndex: number, transportIndex: number, info: any): Promise<any> {
    this.loadingService.start();
    try {

      info.days[daysIndex].transport.splice(transportIndex, 1);

      await this.activeService.updateItineraryLockState(this.withSession({ _id: this.singleItinerary._id, days: info.days }));
      this.messagePopUp(
        "success",
        this.translocoService.translate("itineraries.addEditItinerary.messages.somethingWentWrong"),
        this.translocoService.translate("itineraries.addEditItinerary.messages.transportDeleted")
      );
      this.reloadItinerary();

    } catch (e) {
      this.messagePopUp(
        "error",
        this.translocoService.translate("itineraries.addEditItinerary.messages.somethingWentWrong"),
        this.translocoService.translate("itineraries.addEditItinerary.messages.transportDeleted")
      );
    }
    this.loadingService.stop();
  }

  async onConfirmDeleteExperiences(experiencesIndex: number, experiencesPerDayIndex: number, info: any): Promise<any> {
    this.loadingService.start();
    try {

      info.experiences = info.experiences.map((day: any) => ({
        ...day,
        experiencesPerDay: day.experiencesPerDay.map((experience: any) => ({
          experience: experience?.experience?._id,
          featuredExperience: experience?.featuredExperience,
          notes: experience.notes,
          isPrimaryCurrency: experience?.isPrimaryCurrency,
          isCustomTitle: experience?.isCustomTitle,
          time: experience?.time || null,
          customTitle: experience?.customTitle,
          costPerAdult: experience?.costPerAdult,
          costPerChild: experience?.costPerChild,
          costPerInfant: experience?.costPerInfant,
          conditionType: experience?.conditionType,
          customUrl: experience?.customUrl,
          standaloneImages:  experience?.standaloneImages || [],
          costType: experience?.costType || this.SETTINGS.COST_TYPES_EXPERIENCES[1].value,
          costing: experience?.costing,
          advancedOptions: experience?.advancedOptions

        }))
      }));

      info.experiences[experiencesIndex].experiencesPerDay.splice(experiencesPerDayIndex, 1);

      await this.activeService.updateItineraryLockState(this.withSession({ _id: this.singleItinerary._id, experiences: info.experiences }));
      this.messagePopUp(
        "success",
        this.translocoService.translate("itineraries.addEditItinerary.messages.somethingWentWrong"),
        this.translocoService.translate("itineraries.addEditItinerary.messages.experiencesDeleted")
      );
      this.reloadItinerary();

    } catch (e) {
      this.messagePopUp(
        "error",
        this.translocoService.translate("itineraries.addEditItinerary.messages.somethingWentWrong"),
        this.translocoService.translate("itineraries.addEditItinerary.messages.experiencesDeleted")
      );
    }
    this.loadingService.stop();
  }

  messagePopUp(status: string, errorMessage: string, successMessage: string, editMessage?: string): void {
    if (status === SETTINGS.ITINERARY_MESSAGE_STATUS.ADD_SUCCESS) {
      this.cardLoading = true;
      this.message.success(successMessage);
    }

    if (status === SETTINGS.ITINERARY_MESSAGE_STATUS.EDIT_SUCCESS) {
      this.cardLoading = true;
      this.message.info(editMessage || "");
    }

    if (status === SETTINGS.ITINERARY_MESSAGE_STATUS.ERROR) {
      this.message.error(errorMessage);
    }
  }

  getSelectedImage(): any {
    if (this.images.length === 1) {
      this.featuredForm.controls.image.value = this.images[0];
    }
    return this.featuredForm.controls.image.value;
  }

  toggleImageSelection(img: string): void {
    const current: string[] = this.featuredForm.get('sliderImages')?.value || [];
    const index = current.indexOf(img);
    let next: string[];
    if (index > -1) {
      next = current.filter((i) => i !== img);
    } else if (current.length < 10) {
      next = [...current, img];
    } else {
      return;
    }
    this.featuredForm.get('sliderImages')?.setValue(next);
  }

  isImageSelected(img: string): boolean {
    const current: string[] = this.featuredForm.get('sliderImages')?.value || [];
    return current.includes(img);
  }

  getImageSelectionIndex(img: string): number {
    const current: string[] = this.featuredForm.get('sliderImages')?.value || [];
    return current.indexOf(img) + 1;
  }

  async getGeneratedContent(queryData: any): Promise<any> {
    this.loadingService.start();
    const langType = this.languages?.find((l: any) => l.code === queryData.lang);

    const payload = `Based on the following day-by-day itinerary:${queryData.days
      .filter((day: any) => day?.destination?.city)
      .map((day: any, index: number) => `Day ${index + 1} - ${day.destination.city}, ${day.destination.country || ""}`)
      .join(", ")} The overview should be between 150-225 words in  ${langType.name || "English"} and start with a unique word that has not been used in previous overviews. Ensure the narrative captures the essence of the journey by outlining the destinations travelers will visit`;

    try {
      const answer = await this.openAiService.askChatGPT({ query: payload, number: 1 });
      this.featuredForm.patchValue({ description: answer.choices[0]?.message?.content });
      await this.updateItineraryContent();
      this.loadingService.stop();
    } catch (error) {
      this.loadingService.stop();
    }
  }

  async getGeneratedHighlighContent(queryData: any, index: number): Promise<void> {
    const day = queryData?.days?.[index];
    this.loadingService.start();
    const accommodations = day
      ? getAccommodationPerDate(day.date, queryData?.accommodation)
      : [];

    const accDetails = this.formatAccommodation(accommodations);
    const langType = this.languages?.find((l: any) => l.code === queryData.tour.language);

    const payload = `Generate refined luxury travel Day Highlights based strictly on the provided itinerary data.

    The output must be formatted as clean rich text suitable for direct rendering in a web application (Angular/HTML). Use structured paragraphs with clear spacing and bold section headings.

    DO NOT return plain text blocks. The output must feel visually structured and readable.

    ---

    CONTENT REQUIREMENTS

    Include only the following if provided:
    - accommodations
    - meal plans
    - room category and room type
    - check-in/check-out logic
    - destinations
    - experiences
    - experience timings (exact time, AM/PM, Morning, Midday/Afternoon, Evening, Night)
    - experience inclusion status (included/optional/excluded)
    - flights only (ignore land transfers unless explicitly required)

    DO NOT invent any missing details.

    ---

    WRITING STYLE

    - Write like a luxury travel designer guiding the guest
    - Keep tone warm, natural, and refined
    - Keep sentences short and clean
    - Avoid marketing-heavy or overly poetic language
    - Avoid repetition
    - Do not exaggerate or embellish
    - Humanize the writing naturally
    - Keep descriptions concise but engaging
    - Write naturally as if personally guiding the traveler through the day
    - Do not include check-in / check-out times individually. Use them only to determine itinerary flow.
    - Never explain assumptions or itinerary logic to the guest.
    - Do not mention missing information, inferred timings, or internal reasoning.
    - Apply assumptions silently without phrases such as:
      - "Since no arrival time is provided"
      - "Assuming"
      - "Based on the itinerary"
      - "As per the schedule"
      - "Guests are expected to"

    STRICTLY AVOID phrases like:
    - Wake up to
    - Delight in
    - Indulge in
    - Retire to
    - Perfect way to end the day

    ---

    DAY FLOW LOGIC (CRITICAL)

    - Follow strict chronological order
    - The guest starts the day from the previous night's accommodation
    - Do NOT start the day at a destination they have not yet arrived at
    - Respect realistic movement using:
      - accommodation check-in/check-out timing
      - destination order
      - experience timing
      - flight arrivals

    - Always determine chronological flow based on:
      - accommodation check-in/check-out times
      - flight timings
      - destinations
      - experience timings

    - If the same accommodation is selected for multiple days, naturally continue the flow without repeating unnecessary accommodation details.

    - If no arrival time is provided, assume guests reach the destination in the morning.

    If timing is missing:
    - Morning = start of day
    - Midday = default fallback
    - Evening / Night = as labeled

    ---

    HOTEL STANDARD TIMINGS

    Default hotel check-in:
    - 2:00 PM – 3:00 PM

    Default hotel check-out:
    - 11:00 AM – 12:00 PM

    Standard meal service timings:
    - Breakfast: 6:30 AM – 10:00 AM
    - Lunch: 12:00 PM – 2:30 PM
    - Dinner: 7:00 PM – 10:00 PM
    - Snacks / High Tea (if applicable): 4:00 PM – 6:00 PM

    ---

    MEAL PLAN LOGIC

    RO (Room Only):
    - No meals included.

    EP (European Plan):
    - Equivalent to Room Only.

    B (Breakfast):
    - Breakfast only during breakfast service hours.

    BB (Bed & Breakfast):
    - Breakfast included after the first overnight stay and before check-out on departure day.

    L (Lunch):
    - Lunch only during lunch service hours.

    D (Dinner):
    - Dinner only during dinner service hours.

    HB (Half Board):
    - Typically includes breakfast and dinner.
    - Arrival day usually includes dinner if check-in occurs before dinner hours.
    - Full stay days include breakfast and dinner.
    - Departure day includes breakfast only if checkout occurs after breakfast hours.

    MAP (Modified American Plan):
    - Breakfast plus one additional main meal, usually dinner.

    FB (Full Board):
    - Includes breakfast, lunch, and dinner.
    - Arrival day may include lunch if arrival/check-in occurs before lunch hours, otherwise dinner only.
    - Departure day generally includes breakfast only.

    AP (American Plan):
    - Equivalent to Full Board.

    AI (All Inclusive):
    - Includes meals, beverages, snacks, and selected activities starting from official hotel check-in until official hotel check-out.

    FB+ (Full Board Plus):
    - Same as Full Board with selected beverages included.

    AI+ (All Inclusive Plus):
    - Enhanced All Inclusive package with upgraded inclusions.

    UAI (Ultra All Inclusive):
    - Premium all-inclusive services available throughout the stay.

    Use meal plan logic naturally to guide accommodation narrative and included dining references without repeatedly explaining the meal plan itself.

    ---

    ACCOMMODATION & MEAL RULES

      CRITICAL CHRONOLOGY RULE:
      Accommodation must only appear when the guest can realistically access or use the property.

      The first accommodation reference must follow:

      * actual arrival flow
      * standard hotel check-in timing
      * meal plan usability
      * chronological itinerary progression

      Accommodation must NEVER be introduced early simply because a hotel exists in the itinerary data.

      ARRIVAL FLOW LOGIC

      * If the meal plan starts with Dinner (D/HB/MAP/FB/AI where dinner is the first usable service):

        * The FIRST accommodation mention MUST appear in the Night section.
        * Do NOT mention the hotel in Morning, Midday, or Evening unless check-in is explicitly confirmed earlier.

      * If the meal plan starts with Breakfast only (B/BB):

        * The accommodation should first appear during Night check-in.
        * Breakfast should only appear the following Morning.

      * If arrival/check-in occurs after dinner service:

        * Do NOT mention dinner inclusion.

      * If arrival/check-in occurs before lunch service and the meal plan includes lunch:

        * Lunch may be naturally included in Midday.

      HOTEL REFERENCE RULES

      * Mention accommodation only when operationally meaningful:

        * during realistic check-in flow
        * when tied to included meals
        * when overnight context improves readability

      * Avoid introducing accommodation too early in the day narrative.

      * Do not repeatedly mention:

        * hotel name
        * room category
        * room type

      * After the first accommodation reference, avoid repeating the property unless operationally necessary.

      * If the same hotel spans multiple days:

        * continue the narrative naturally without reintroducing full accommodation details every day.

      WRITING RULES

      Avoid robotic phrasing such as:

      * "Your accommodation tonight is..."
      * "Guests will stay at..."
      * "Accommodation for the night is..."

      Prefer natural luxury travel phrasing such as:

      * "Tonight's stay is at..."
      * "The evening concludes at..."
      * "Guests check in to..."
      * "Dinner is served as part of the stay at..."

      Never force accommodation sentences into sections where they do not naturally belong.

      Destination and experience flow must always take priority over hotel descriptions.


    EXPERIENCE RULES

    - Write experiences in chronological order.
    - Keep the flow natural and easy to follow.
    - Do not combine too many activities in one sentence.
    - If multiple experiences exist within the same section, write them in separate natural sentences.
    - If no experience timing is provided, assume Midday.

    - Prioritize natural narrative flow over template-style sentence construction.
    - Vary sentence openings and structure across sections.

    - Avoid repetitive sequencing patterns such as:
      - "Continue the day with..."
      - "Spend the evening..."
      - "The night is open for..."

    - Do not create standalone sentences purely to explain inclusion status.

    - Blend inclusion status naturally into the experience narrative using contextual phrasing.

    - Use natural phrasing patterns such as:
      - "As an included experience..."
      - "Included in the journey is..."
      - "The day also features..."
      - "Guests may optionally visit..."
      - "An optional experience includes..."
      - "Guests may independently explore..."
      - "Although not included..."
      - "This excluded experience can still be enjoyed independently..."

    - Avoid robotic endings such as:
      - "This experience is included"
      - "This experience is optional"
      - "This experience is excluded"

    - Optional and excluded experiences should feel naturally suggestive rather than operationally labelled.

    - If inclusion status is not important to itinerary flow, it does not need to be mentioned.

    ---

    TRANSPORT RULE

    - Mention ONLY flights if present.
    - Ignore all land transfers completely unless explicitly required.

    ---

    STRUCTURE (MANDATORY)

    Divide output into ONLY these four sections in this exact order:

    Morning
    Midday
    Evening
    Night

    ---

    RICH TEXT FORMATTING RULES (VERY IMPORTANT)

    - Use <p> for paragraphs
    - Use <strong> for section headings
    - Each section must be clearly separated
    - Keep spacing clean and readable

    Example format:

    <p><strong>Morning</strong></p>
    <p>Text here...</p>

    <p><strong>Midday</strong></p>
    <p>Text here...</p>

    ---

    OUTPUT RULES

    - Do NOT include titles like "Day Highlights"
    - Do NOT include extra explanations
    - Do NOT include markdown
    - Do NOT include HTML wrappers like <html> or <body>
    - Do NOT end headings with a colon
    - Output must be directly renderable rich text
    - Content must be in English
    - Stick strictly to the itinerary details provided
    - Content should be in ${langType.name || "English"}
    ---
    Destination: ${day.destination.city}, ${day.destination?.country || ""}
    Accommodation: ${accDetails}
    Transport: ${day.transport
          .map(
            (trans:any) =>
              `from ${trans.displayNameFrom} to ${trans.displayNameTo}, traveling via ${trans?.typeOfVehicle || "private vehicle"}`
          )
          .join(", ")}
    Experiences: ${queryData.experiences[index].experiencesPerDay
          .map((exp:any) => `${exp?.experience?.name || ""}${exp?.time ? ` - ${exp.time}` : ""}${exp?.conditionType ? ` (${this.getConditionTypeLabel(exp.conditionType)})` : ""}`)
          .join(", ")}
    `;

    try {
      const answer = await this.openAiService.generateMiniContent({ query: payload, number: 1 });
      this.singleItinerary.days[index].remarksTips = answer.choices[0]?.message?.content;
      this.remarksTips = answer.choices[0]?.message?.content;
      await this.updateItineraryContent();
      this.loadingService.stop();
    } catch (error) {
      this.loadingService.stop();
    }
  }

  formatAccommodation = (a: any) => {
    const roomsText = (a[0].rooms ?? [])
      .map((r: any) => {
        const parts = [
          r.roomType ? `Room type - ${r.roomType}` : "",
          r.roomCategory ? `category - ${r.roomCategory}` : "",
          r.mealType ? `meal plan - ${r.mealType}` : "",
        ].filter(Boolean);
        return parts.join(", ");
      })
      .join("; ");
    return `Accommodation - Name - ${a[0].name}${roomsText ? ", " + roomsText : ""}`;
  };

  getConditionTypeLabel = (value: string): string => {
    return SETTINGS.CONDITION_TYPES.find((c: any) => c.value === value && c.language === 'en')?.label || value || "";
  };

  isDisableHighlightButton(index: number): boolean {
    const day = this.singleItinerary?.days?.[index];
    const experience = this.singleItinerary?.experiences?.[index];
    const transport = this.singleItinerary?.transport?.[index];

    const accommodations = day
      ? getAccommodationPerDate(day.date, this.singleItinerary?.accommodation)
      : [];

    return day?.destination === undefined
      || experience?.experiencesPerDay?.length === 0
      || transport?.length === 0
      || accommodations?.length === 0
      || this.singleItinerary?.lock === null;
  }

  async getGeneratedHighlighDepatureContent(queryData: any, index: number): Promise<void> {
    const day = queryData?.days?.[index];
    const langType = this.languages?.find((l: any) => l.code === queryData.tour.language);
    this.loadingService.start();
    const payload = `
        Generate a natural, two-sentence highlight for a departure day itinerary.
        Write it in a friendly and engaging tone that connects the transport route and experiences, giving a sense of closure to the journey.
        Format using only <strong>, <i>, and <li> tags within <ul> where needed.
        Do NOT include any wrapping tags like <html>, <head>, <body>, or external container tags.
        Content should be in ${langType.name || "English"}

        Transport: ${day.transport
        .map(
          (trans:any) =>
            `from ${trans.displayNameTo} to ${trans.displayNameFrom}, traveling via ${trans?.typeOfVehicle || "private vehicle"}`
        )
      .join(", ")}
        Experiences: ${queryData.experiences[index].experiencesPerDay
      .map((exp:any) => `${exp?.experience?.name || ""}${exp?.time ? ` - ${exp.time}` : ""}${exp?.conditionType ? ` (${this.getConditionTypeLabel(exp.conditionType)})` : ""}`)
      .join(", ")}
        `;
    try {
      const answer = await this.openAiService.askChatGPTGeneral({ query: payload, number: 1 });
      this.singleItinerary.days[index].remarksTips = answer.choices[0]?.message?.content;
      this.remarksTips = answer.choices[0]?.message?.content;
      await this.updateItineraryContent();
      this.loadingService.stop();
    } catch (error) {
      this.loadingService.stop();
    }
  }

  isDisableHighlightDepatureButton(index: number): boolean {
    const experience = this.singleItinerary?.experiences?.[index];
    const transport = this.singleItinerary?.days[index].transport;
    const firstExperience = experience?.experiencesPerDay[0];
    const isNotEmptyObject = experience?.length === 0 && Object.keys(firstExperience).length > 0;
    return (isNotEmptyObject  )
      || transport?.length === 0
      || this.singleItinerary?.lock === null;
  }

  addImage(imageName: any): void {
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate("itineraries.addEditItinerary.modals.addImage"),
        nzWidth: "700px",
        nzContent: AddImageModelComponent,
        nzFooter: null,
        nzComponentParams: {
          imageName
          // images
        },
      })
      .afterClose.subscribe(data => {
        if (data !== undefined) {
          this.images.push(data);
          this.activeService.updateItineraryLockState(this.withSession({
            _id: this.singleItinerary._id, images: this.images
          })).then();
        }
        this.ngOnInit();
      });
  }

  onChangeDepartureCheckedBox(event: any): void {
    this.departureBoxChecked = event;
    this.singleItinerary.days[this.singleItinerary.days.length - 1].remarksTips = '';
    this.remarksTips= ''
    if (this.departureBoxChecked) {
      this.singleItinerary.days[this.singleItinerary.days.length - 1].destination = null;
      delete this.singleItinerary.days[this.singleItinerary.days.length - 1]?.featuredDestination;
    }
  }

  onClickNavigateEdit(): void {
    const editPath = this.mode === 'template'
      ? "/admin/template-itinerary/edit/details"
      : "/admin/itineraries/edit/details";
    this.router.navigate([editPath, this.singleItinerary?._id]);
  }

  findDaysIndex(days: any, destinationId: any): number[] {
    const values: any = [];
    for (let i = 0; i < days.length; i++) {
      if (days[i]?.destination?._id === destinationId) {
        values.push(i);
      }
    }
    return values;
  }

  findExperienceIndex(experiences: any, experiencesID: any): number[] {
    const values: any = [];

    // Iterate over the experiences array
    for (let i = 0; i < experiences.length; i++) {
      const experiencesPerDay = experiences[i].experiencesPerDay;

      for (let j = 0; j < experiencesPerDay.length; j++) {
        if (experiencesPerDay[j]?.experience?._id === experiencesID) {
          values.push(i);
          break; // avoid looping further
        }
      }

    }
    return values;
  }

  public removeItem(item: any, list: any[]): void {
    list.splice(list.indexOf(item), 1);
  }

  // drag and drop events

  onCostDragStart(event: any, costIndex: number): void {
    this.draggedIndex = costIndex;
  }

  onCostDragOver(event: any): void {
    event.preventDefault();
  }

  onCostDrop(event: any, targetIndex: number): void {
    event.preventDefault();

    const draggedIndex = this.draggedIndex;
    if (draggedIndex === null) {
      return;
    }

    // Call a method to reorder the form array
    this.reorderFormArray(draggedIndex, targetIndex);
    this.draggedIndex = null;
  }

  reorderFormArray(fromIndex: number, toIndex: number): void {
    const additionalCostsArray = this.costingForm.get("additionalCosts") as FormArray;

    if (fromIndex !== toIndex) {
      const draggedItem = additionalCostsArray.at(fromIndex);
      additionalCostsArray.removeAt(fromIndex);
      additionalCostsArray.insert(toIndex, draggedItem);
    }
  }

  // totalCost editable field change.
  totalCostOnChange(event: boolean): void {
    if (event) {
      this.isSubTotalManual = event;
      this.costingForm.controls.totalCost.enable();
    } else {
      this.isSubTotalManual = event;
      this.costingForm.controls.totalCost.disable();
      this.newCalculateTotalCost();
    }
  }

  dynamicPricingOnChange(event: boolean): void {
    this.isDynamicPricing = event;

    if (this.isDynamicPricing) {
      const dynamicPricingTable = this.costingForm.get("dynamicPricing")?.value
      if ( dynamicPricingTable?.headers?.length === 0 || dynamicPricingTable === undefined ) {
        this.defaultDynamicValues();
      }
    }
  }

  removeAdditionalCost(roomIndex: number): void {
    const costing = this.costingForm.getRawValue();
    const deleteCost = costing.additionalCosts[roomIndex];
    if (deleteCost.entryType === "PRE") {
      this.findMatchingCosting(deleteCost.title, deleteCost.cost);
    }
    this.getAdditionalCosts().removeAt(roomIndex);
  }

  getDayAdditionalCosts(dayIndex: number): { title: string; cost: number; costCalSymbol: string }[] {
    if (!this.singleItinerary.days[dayIndex].additionalCosts) {
      this.singleItinerary.days[dayIndex].additionalCosts = [];
    }
    return this.singleItinerary.days[dayIndex].additionalCosts;
  }

  getDayAdditionalCostsSubtotal(dayIndex: number): number {
    const costs = this.getDayAdditionalCosts(dayIndex);
    return costs.reduce((sum, ac) => sum + (ac.cost || 0), 0);
  }

  getTotalAdditionalCostsPerDay(): number {
    return this.singleItinerary.days.reduce((total: number, _: any, index: number) => {
      return total + this.getDayAdditionalCostsSubtotal(index);
    }, 0);
  }

  addDayAdditionalCost(dayIndex: number): void {
    if (!this.singleItinerary.days[dayIndex].additionalCosts) {
      this.singleItinerary.days[dayIndex].additionalCosts = [];
    }
    this.singleItinerary.days[dayIndex].additionalCosts.push({
      title: '',
      cost: 0,
      costCalSymbol: 'FIXED',
    });
    this.newCalculateTotalCost();
  }

  removeDayAdditionalCost(dayIndex: number, costIndex: number): void {
    this.singleItinerary.days[dayIndex].additionalCosts.splice(costIndex, 1);
    this.newCalculateTotalCost();
  }

  getDayInclusions(dayIndex: number): string[] {
    if (!this.singleItinerary.days[dayIndex].inclusions) {
      this.singleItinerary.days[dayIndex].inclusions = [];
    }
    return this.singleItinerary.days[dayIndex].inclusions;
  }

  getDayExclusions(dayIndex: number): string[] {
    if (!this.singleItinerary.days[dayIndex].exclusions) {
      this.singleItinerary.days[dayIndex].exclusions = [];
    }
    return this.singleItinerary.days[dayIndex].exclusions;
  }

  addDayInclusion(dayIndex: number): void {
    this.getDayInclusions(dayIndex).push('');
  }

  addDayExclusion(dayIndex: number): void {
    this.getDayExclusions(dayIndex).push('');
  }

  removeDayInclusion(dayIndex: number, incIndex: number): void {
    this.singleItinerary.days[dayIndex].inclusions.splice(incIndex, 1);
  }

  removeDayExclusion(dayIndex: number, excIndex: number): void {
    this.singleItinerary.days[dayIndex].exclusions.splice(excIndex, 1);
  }

  trackByIndex(index: number): number {
    return index;
  }

  deleteImage(img: any): void {
    this.cardLoading = true;
    this.images = this.images.filter((i: any) => i !== img);
    this.singleItinerary.images = [...this.images];

    this.activeService.updateItineraryLockState(this.withSession({
      _id: this.singleItinerary._id,
      images: this.images
    })).then(() => {
      this.cardLoading = false;
    });
  }

  editPreDefinedAdditionalCost(roomIndex: number): void {
    const costing = this.costingForm.getRawValue();
    const selectedCost = costing.additionalCosts[roomIndex];
    this.findMatchingCosting(selectedCost.title, selectedCost.cost);
    const entry = this.getAdditionalCosts().at(roomIndex);
    entry.patchValue({ ...selectedCost, entryType: "TYPED" });
    this.costingForm.get("additionalCosts").at(roomIndex).get("title").enable();
  }

  findMatchingCosting(title: string, cost: number): void {
    const { predefinedCosting } = this.brand;
    const match = predefinedCosting.find((item: any) => item.title === title && item.cost === cost);
    if (match !== null) {
      this.excludeCost.push({ id: match._id });
    }
  }

  async generateLink(): Promise<void> {
    this.cardLoading = true;
    const updatePayload = {
      ...this.singleItinerary.b2b,
      time: moment()
    };
    const theme = SETTINGS.THEME_TYPES_NAVI_B2B.find(theme => theme.value === this.singleItinerary.tour.themeType);
    try {
      await this.activeService.updateItineraryLockState(this.withSession({
        _id: this.singleItinerary._id,
        b2b: updatePayload,
      }));
      const params = new URLSearchParams({ rretMgxg: "nono" });
      const baseUrl = this.getHostnameUrl();
      this.clipboard.copy(`${baseUrl}${theme?.url}/${this.singleItinerary._id}/${false}?${params.toString()}`);
      this.message.success(this.translocoService.translate("itineraries.messages.editableLinkCopied"));
      this.ngOnInit();
      this.cardLoading = false;
    } catch (e) {
      this.cardLoading = false;
      this.message.error(this.translocoService.translate("itineraries.addEditItinerary.messages.linkGenerateFailed"));
    }
  }

  copyGeneratedLink(): void {
    const theme = SETTINGS.THEME_TYPES_NAVI_B2B.find(theme => theme.value === this.singleItinerary.tour.themeType);
    const params = new URLSearchParams({ rretMgxg: "nono" });
    const baseUrl = this.getHostnameUrl();
    this.clipboard.copy(`${baseUrl}${theme?.url}/${this.singleItinerary._id}/${false}?${params.toString()}`);
    this.message.success(this.translocoService.translate("itineraries.messages.editableLinkCopied"));
  }

  onClickNavigateToPreview(inti: any): void {
    let theme
    if (this.mode === 'template') {
      theme = SETTINGS.THEME_TYPES_NAVI_B2C_TEMPLATE.find(theme => theme.value === inti.tour.themeType);
    }else{
      theme = SETTINGS.THEME_TYPES_NAVI_B2C.find(theme => theme.value === inti.tour.themeType);
    }

    const params = new URLSearchParams({ rretMgxg: "ffliwqadrjt" });
    const baseUrl = this.getHostnameUrl();
    window.open(`${baseUrl}${theme?.url}/${inti._id}/false?${params.toString()}`, "_blank");
  }

  getHostnameUrl(): string {
    return this.settingService.hostnameUrl || environment.previewLink;
  }

  async onChangeThemeType(value: string): Promise<void> {
    this.loadingService.start();
    const updatePayload = {
      tour: { ...this.singleItinerary.tour, themeType: value }
    };
    try {
      await this.activeService.updateItineraryLockState(this.withSession({
        _id: this.singleItinerary._id,
        ...updatePayload,
      }));
      this.singleItinerary.tour.themeType = value;
      this.loadingService.stop();
    } catch (e) {
      this.message.error(this.translocoService.translate("itineraries.addEditItinerary.messages.failedToUpdateThemeType"));
      this.loadingService.stop();
    }
  }

  determineRedirect(user: any, redirectTo: string): void {
    if (user.role.isSuperAdmin) {
      this.router.navigate([redirectTo]);
    } else {
      this.messageService.error(this.translocoService.translate("itineraries.addEditItinerary.messages.subscriptionIssue"));
      this.authService.logout();
    }
  }

  // TODO moving forward need to write a common component(using in itineraries page as well) for email via modal,
  sendItineraryShowModal(
    id: string,
    creator: string,
    customer: string,
    email: string,
    themeType: string
  ): void {
    this.modalTitle = this.translocoService.translate("itineraries.emailModal.sendItineraryTitle");
    this.modalTitleConfirmBox = this.translocoService.translate("itineraries.emailModal.sendItineraryConfirmTitle");
    this.subject = this.translocoService.translate("itineraries.emailModal.itinerarySubject");
    this.sendInfo = {
      id,
      creator,
      customer,
      email,
      type: "Itinerary",
      themeType
    };
    this.itineraryId = id;
    this.showModal();
  }

  showModal(): void {
    if (this.sendInfo.email.length !== 0) {
      this.emailForm.patchValue({
        sendEmailTo: [this.sendInfo.email],
        sendEmailCc: [],
        sendEmailSubject: this.subject,
      });
    } else {
      this.messageService.warning(this.translocoService.translate("itineraries.messages.defaultCustomerEmailMissing"));
      this.emailForm.patchValue({
        sendEmailTo: [],
        sendEmailCc: [],
        sendEmailSubject: this.subject,
      });
    }

    this.sendEmailIsVisible = true;
  }

  sendEmailConfirmModal(): void {
    this.sendEmailConfirmIsVisible = true;
  }

  sendEmailCancel(event: string): void {
    if (event === "emailModal") {
      this.sendEmailIsVisible = false;
      this.sendEmailConfirmIsVisible = false;
    } else {
      this.sendEmailConfirmIsVisible = false;
    }
  }

  setDefaultClientMail(event: any): void {
    const eventArr: any[] = [];
    if (event.includes(this.sendInfo.email)) {
      return;
    } else {
      // event.forEach((res: any) => {
      //   eventArr.push(res);
      // });
      // eventArr.unshift(this.sendInfo.email);
      this.emailForm.get("sendEmailTo").patchValue(event);
      // this.formErrors.sendEmailTo.remove = true;
      return;
    }
  }

  async SendEmail(): Promise<void> {
    this.loadingService.start();
    this.sendEmailCancel("emailModal");
    const emailFormInfo = this.emailForm.getRawValue();
    let payload = {};

    // block to send pdf data or not
    if (this.sendInfo.type === "Itinerary" && this.attachWithPDFChecked) {
      const pdfData = await this.getPDFData();
      payload = { sendInfo: this.sendInfo, emailFormInfo, pdf: pdfData, isAttachPDF: this.attachWithPDFChecked };
    } else {
      payload = { sendInfo: this.sendInfo, emailFormInfo };
    }

    if (this.sendInfo.type === "Itinerary") {
      try {
        this.loadingService.start();
        await this.itineraryService.emailSendToCustomerItinerary(payload);
        this.attachWithPDFChecked = false;
        await this.activeService.updateItinerary({ _id: this.sendInfo.id, isStatusUpdate: true, isSent: true, status: SETTINGS.ITINERARY_STATUSES.SENT });
        this.loadingService.stop();
        this.messageService.success(this.translocoService.translate("itineraries.messages.itinerarySent"));
      } catch (e: any) {
        this.attachWithPDFChecked = false;
        this.loadingService.stop();
        this.messageService.error(e?.error?.message || this.translocoService.translate("itineraries.messages.failedToSendItinerary"));
      }
    }

  }

  async getPDFData(): Promise<any> {
    try {
      let mapUrl: any = null;
      mapUrl = this.mapType === SETTINGS.MAP_TYPES[0].value ?  await this.mapDirectionsImage() : this.mapImage();
        const countryImageURL = this.singleItinerary?.tour?.customer?.country?.code ?
          this.findCountryFlagImage(this.singleItinerary?.tour.customer.country.code) : "";
        const b2b = this.singleItinerary?.tour?.type === "B2B" ? {
          itinerary: this.singleItinerary?.itinerary,
          companyName: this.singleItinerary?.b2b?.customer?.companyName || "",
          logo: this.singleItinerary?.b2b?.customer?.logo,
          costing: this.singleItinerary?.b2b?.costing,
          companyDetails: {summary: this.singleItinerary?.b2b?.customer?.summary || "" , websiteLink: this.singleItinerary?.b2b?.customer?.websiteLink || null},
        } : "";
        const payload = {
          day: this.singleItinerary?.days.length,
          night: this.singleItinerary?.days.length - 1,
          clientTimezoneOffset: new Date().getTimezoneOffset(),
          ...this.singleItinerary,
          ...this.brand,
          citiesByCountry: this.citiesByCountry,
          countries: this.countries,
          mapURL: mapUrl,
          ...b2b,
          countryImageURL,
          pdfViewOptions: SETTINGS.PDF_VIEW_OPTIONS
        };
        return payload;
    }catch (e) {
      console.log(e);
    }
  }

  generatePDF(): void {
    this.loadingService.start();
    let mapUrl: any = null;
    Promise.all([this.loadItineraryByID()]).then(async () => {
      mapUrl = this.mapType === SETTINGS.MAP_TYPES[0].value ?  await this.mapDirectionsImage() : this.mapImage();
      const countryImageURL = this.singleItinerary.tour?.customer?.country?.code ?
        this.findCountryFlagImage(this.singleItinerary?.tour.customer.country.code) : "";
      const b2b = this.singleItinerary?.tour?.type === "B2B" ? {
        itinerary: this.singleItinerary?.itinerary,
        companyName: this.singleItinerary?.b2b?.customer?.companyName || "",
        logo: this.singleItinerary?.b2b?.customer?.logo,
        costing: this.singleItinerary?.b2b?.costing,
        companyDetails: {summary: this.singleItinerary?.b2b?.customer?.summary || "" , websiteLink: this.singleItinerary?.b2b?.customer?.websiteLink || null},
      } : "";
      const payload = {
        day: this.singleItinerary.days.length,
        night: this.singleItinerary.days.length - 1,
        clientTimezoneOffset: new Date().getTimezoneOffset(),
        ...this.singleItinerary,
        ...this.brand,
        citiesByCountry: this.citiesByCountry,
        countries: this.countries,
        mapURL: mapUrl,
        countryImageURL,
        ...b2b
      };
      this.reportService.generateItineraryReport(payload).then((res) => {
        const fileName = `${this.singleItinerary.tour.referenceNo}-${this.singleItinerary?.b2b?.customer?.companyName ? this.singleItinerary?.b2b?.customer?.companyName : this.getNoNameFallback()} `;
        this.reportService.downloadReport(res, fileName);
        this.loadingService.stop();
      });
    });
  }

  exportContent(id: any): void {
    const viewSettings = this.getCurrentUpdatePayload().viewSettings;
    this.nzModalService
      .create({
        nzClosable: false,
        nzTitle: this.translocoService.translate("itineraries.addEditItinerary.modals.exportOptions"),
        nzWidth: "700px",
        nzContent: ExportContentComponent,
        nzFooter: null,
        nzComponentParams: {
          id,
          viewSettings,
          currentThemeType: this.themeType
        },
      })
      .afterClose.subscribe(data => {
    });
  }


  experiencesReorder(dayIndex: number ): void {
    const experiences = this.singleItinerary.experiences;
    const lang = this.singleItinerary?.tour?.language
    const id = this.singleItinerary?._id;
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate("itineraries.addEditItinerary.modals.reorderExperiences"),
        nzWidth: "500px",
        nzContent: ExperiencesDragComponent,
        nzFooter: null,
        nzComponentParams: {
          dayIndex,
          experiences,
          lang,
          id,
          itineraryMode: this.mode,
          sessionId: this.tabSessionId,
        },
      })
      .afterClose.subscribe(data => {
        this.reloadItinerary();
    });
  }


  onClickMoveDeleteModal(): void {
    const { experiences, _id: id, days, accommodation, tour } = this.singleItinerary;
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate("itineraries.addEditItinerary.modals.manageDays"),
        nzWidth: "500px",
        nzContent: MoveDeleteDaysComponent,
        nzFooter: null,
        nzComponentParams: {
          days: structuredClone(days),
          accommodation: structuredClone(accommodation),
          experiences: structuredClone(experiences),
          id,
          tourInfo: structuredClone(tour),
          itineraryMode: this.mode,
          sessionId: this.tabSessionId,
        },
      })
      .afterClose.subscribe(data => {
        if (data?.message === "success") {
          this.reloadItinerary();
        }
      });
  }

  countrySequence(): void {
    this.singleItinerary?.days.forEach((day: any) => {
      const country = day?.destination?.country;
      if (!this.countries.includes(country)) {
        this.countries.push(country);
      }
    });
  }

  citySequence(): void {
    this.singleItinerary?.days.forEach((day: any) => {
      const country = day?.destination?.country;
      const city = day?.destination?.city;

      const countryIndex = this.citiesByCountry.findIndex((item: any) => item?.country === country);

      if (countryIndex === -1) {
        this.citiesByCountry.push({ country, cities: [city] });
      } else {
        // If country already exists, add city only if it's not already present
        if (!this.citiesByCountry[countryIndex].cities.includes(city)) {
          this.citiesByCountry[countryIndex].cities.push(city);
        }
      }
    });
  }

  mapImage(): string {
    let geoJSON: any | undefined;

    if (this.singleItinerary?.days[0]?.transport.length !== 0) {
      const { locationFrom } = this.singleItinerary?.days[0]?.transport[0];
      if (locationFrom) {
        geoJSON = geoJSONManager(geoJSON, parseFloat(locationFrom?.latitude), parseFloat(locationFrom?.longitude));
      }
    }

    this.singleItinerary.days.forEach((day: any) => {
      if (day?.destination) {
        const { location } = day?.destination;
        geoJSON = geoJSONManager(geoJSON, parseFloat(location?.latitude), parseFloat(location?.longitude));
      }
    });

    const lastDay = this.singleItinerary.days.length - 1;
    if (this.singleItinerary?.days[lastDay]?.transport.length !== 0) {
      const lastTransport = this.singleItinerary?.days[lastDay]?.transport.length - 1;
      const { locationTo } = this.singleItinerary?.days[lastDay]?.transport[lastTransport];
      if (locationTo) {
        geoJSON = geoJSONManager(geoJSON, parseFloat(locationTo?.latitude), parseFloat(locationTo?.longitude));
      }
    }

    return this.mapBoxService.getStaticMapURL(geoJSON);
  }

  async mapDirectionsImage(): Promise<any> {
    try {
      // Collect all waypoints from the itinerary
      const waypoints: Array<{lat: number, lng: number}> = [];

      // Add starting point from first transport
      if (this.singleItinerary?.days[0]?.transport.length !== 0) {
        const {locationFrom} = this.singleItinerary?.days[0]?.transport[0];
        if (locationFrom) {
          waypoints.push({
            lat: parseFloat(locationFrom.latitude),
            lng: parseFloat(locationFrom.longitude)
          });
        }
      }

      let prevId: string | undefined;
      // Add destination points
      for (const day of this.singleItinerary?.days ?? []) {
        const dest = day?.destination;
        if (!dest?.location) {
          continue;
        }

        const curId = dest._id as string | undefined;
        if (curId && curId === prevId) {
          continue;
        }

        const {latitude, longitude} = dest.location;
        const lat = typeof latitude === "number" ? latitude : parseFloat(latitude);
        const lng = typeof longitude === "number" ? longitude : parseFloat(longitude);
        if (Number.isFinite(lat) && Number.isFinite(lng)) {
          waypoints.push({lat, lng});
        }
        prevId = curId;
      }

      // Add ending point from last transport
      const lastDay = this.singleItinerary.days.length - 1;
      if (this.singleItinerary?.days[lastDay]?.transport.length !== 0) {
        const lastTransport = this.singleItinerary?.days[lastDay]?.transport.length - 1;
        const {locationTo} = this.singleItinerary?.days[lastDay]?.transport[lastTransport];
        if (locationTo) {
          waypoints.push({
            lat: parseFloat(locationTo.latitude),
            lng: parseFloat(locationTo.longitude)
          });
        }
      }
      return await this.mapBoxService.getStaticMapWithDirections(false, waypoints);
    } catch (e) {
      console.error('Error generating map image with directions:', e);
      return null;
    }
  }

  findCountryFlagImage(countryCode: string): string {
    const selected_country = this.countriesJson.find(
      (c: any) => c.code === countryCode
    );
    return selected_country?.image;
  }
  async getCountries(): Promise<void> {
    this.countriesJson = await this.countryService.getCountries();
  }

  emailValidator = (control: FormControl) => {
    let isEmail = false;
    control.value.forEach((val: any) => {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!regex.test(val as string)) {
        isEmail = true;
      }
    });
    if (isEmail) {
      return { email: true };
    } else {
      return {};
    }
  }

  routeBackToItinerariesTable(): void {
    const listPath = this.mode === 'template'
      ?  "/admin/template-itinerary"
      : this.isTemplateAdd ? "/admin/template-itinerary" : "/admin/itineraries";
    this.router.navigate([listPath]);
  }

  getCurrentUpdatePayload(): any {
    const costing = this.costingForm.getRawValue();
    const settings = {
      isTourCostHidden: this.costingBoxChecked,
      // isTourOperatorHidden: this.tourOperatorBoxChecked,
      // isCompanyDetailsHidden: this.companyInformationBoxChecked,
      isDepartureChecked: this.departureBoxChecked,
      isMileageChecked: this.mileageBoxChecked,
      isTravelTimeChecked: this.travelTimeBoxChecked,
      isVehicleNameChecked: this.vehicleNameBoxChecked,
      isVehicleImageChecked: this.vehicleImageBoxChecked,
      isRemarksTipsChecked: this.remarksTipsBoxChecked,
      isItineraryTitleChecked: this.itineraryTitleBoxChecked,
      isItineraryReferenceNumberChecked: this.itineraryReferenceNumberBoxChecked,
      isHotelRatingChecked: this.hotelRatingBoxChecked,
      isHotelDescriptionChecked: this.hotelDescriptionBoxChecked,
      isHotelWebsiteChecked: this.hotelWebsiteBoxChecked,
      isHotelImageChecked: this.hotelImageBoxChecked,
      isWebsiteLinkChecked: this.websiteLinkBoxChecked,
      isPaymentLinkChecked: this.paymentLinkBoxChecked,
      isCustomerInformationChecked: this.customerInformationBoxChecked,
      isDisplayMapTopsideChecked: this.displayMapTopsideBoxChecked,
      isThumbnailChecked: this.thumbnailBoxChecked,
      isDaywiseInclusionsExclusionsChecked: this.hideDaywiseInclusionsExclusionsBoxChecked,
      isIncludeBadgeChecked: this.includeBadgeBoxChecked,
      isExcludeBadgeChecked: this.excludeBadgeBoxChecked,
      isAccommodationNoteChecked: this.accommodationNoteBoxChecked,
      isAccommodationRoomsChecked: this.accommodationRoomsBoxChecked,
      isTransportNoteChecked: this.transportNoteBoxChecked,
      isExperiencesNoteChecked: this.experiencesNoteBoxChecked,
      isExperiencesTimesChecked: this.hideExperiencesTimesBoxChecked,
      isPricingRemarksChecked: this.pricingRemarksBoxChecked,
      isAdditionalNotesChecked: this.additionalNotesBoxChecked,
      mapType: this.mapType

    };
    const cSettings = {
      isSubTotalManual: this.isSubTotalManual,
      isDynamicPricing: this.isDynamicPricing,
    };
    return {
      featured: this.featuredForm?.getRawValue?.() || {},
      itinerary: this.itineraryForm?.getRawValue?.() || {},
      ...(this.titleForm?.getRawValue?.() || {}),
      // days: this.singleItinerary?.days || [],
      costing,
      viewSettings: settings,
      costSettings: cSettings,
      paymentLink: this.paymentLink,
      remarks: this.remarks,
      additionalNotes: this.buildAdditionalNotesPayload(),
      excludePredefinedCost: this.excludeCost,
      days: this.singleItinerary?.days,
    };
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.isAdd && this.singleItinerary?.lock !== null) {
      const currentPayload = _.cloneDeep(this.getCurrentUpdatePayload());
      if (!_.isEqual(currentPayload, this.originalPayload)) {
        // wrap nzConfirm in a Promise that resolves to true/false
        return new Promise<boolean>(resolve => {
          this.updateItineraryContent(false).then(() => {
            this.removeItineraryStateLock().then(() => resolve(true)).catch((err) => () => resolve(true));
          }).catch((err: any) => {
            resolve(true);
          });
        });
      }else {
        return new Promise<boolean>(resolve => {
          this.removeItineraryStateLock().then(() => resolve(true)).catch((err) => () => resolve(true));
        });
      }
    }
    return of(true);
  }
  // TODO remove if is not needed in the future
  private userIdle(): void {
    if (!this.isAdd && this.singleItinerary?.lock !== null) {
      const activity$ = merge(
        fromEvent(document, 'mousemove'),
        fromEvent(document, 'keydown')
        // add fromEvent(document, 'touchstart') if you need mobile
      );

      // Fires AFTER 4s of no mouse/keys
      this.idleSub = activity$
        .pipe(debounceTime(6000))
        .subscribe(async () => {
          const currentPayload = _.cloneDeep(this.getCurrentUpdatePayload());
          if (!_.isEqual(currentPayload, this.originalPayload)) {
            await this.autoUpdateItineraryContent(false);
          }
        });
    }
  }

  private extendLockStateSub(): void {
    if (!this.isAdd && this.singleItinerary?.lock !== null) {
      this.extendSub = interval(45000).subscribe(async () => {
          await this.extendLockState();
      });
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: any): string | void {
    const currentPayload = _.cloneDeep(this.getCurrentUpdatePayload());
    if (!this.isAdd && this.singleItinerary?.lock !== null) {
      if (!_.isEqual(currentPayload, this.originalPayload)) {
        // Show confirmation dialog to warn user about unsaved changes
        const message = this.t("itineraries.addEditItinerary.messages.unsavedChangesBeforeLeave");
        event.preventDefault();
        event.returnValue = message;
        return message;
      }
    }
  }

   startValueChangesWatcher(): void {
     if (!this.isAdd && this.singleItinerary?.lock !== null) {
       // Emits ONLY when the payload changes compared to the original
       const changes$ = interval(500).pipe( // light poll to detect form changes; adjust if you like
         map(() => _.cloneDeep(this.getCurrentUpdatePayload())),
         distinctUntilChanged((a, b) => _.isEqual(a, b)), // emit on any structural change
         map(payload => !_.isEqual(payload, this.originalPayload)), // compare with original
         filter(changed => changed), // only when different from original
         share() // share for takeUntil below
       );

       // Debounce: wait 8s after the LAST change before updating
       this.pollSub = changes$.pipe(
         switchMap(() =>
           timer(7000).pipe(
             // if another change happens before 8s, cancel this timer and restart
             takeUntil(changes$)
           )
         )
       ).subscribe(async () => {
         const currentPayload = _.cloneDeep(this.getCurrentUpdatePayload());
         // still guard right before calling update
         if (!_.isEqual(currentPayload, this.originalPayload)) {
           await this.autoUpdateItineraryContent(false);
         }
       });
     }
  }


 async removeItineraryStateLock(): Promise<void> {
    try {
      await this.activeService.removeItineraryLockState(this.singleItinerary._id, this.tabSessionId);
    }catch (e: any) {
      console.log(e?.message?.message || e);
    }
  }

  private getTabSessionId(): string {
    const storageKey = 'itineraryTabSessionId';
    if (this.isPageReload()) {
      const stored = sessionStorage.getItem(storageKey);
      if (stored) {
        return stored;
      }
    }
    return (crypto as any).randomUUID?.() ?? `${Date.now()}-${Math.random()}`;
  }

  private isPageReload(): boolean {
    const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
    if (navEntry?.type === 'reload') {
      return true;
    }
    const legacyNav = (performance as Performance & { navigation?: { type?: number } }).navigation;
    return legacyNav?.type === 1;
  }

  private persistTabSessionId(): void {
    sessionStorage.setItem('itineraryTabSessionId', this.tabSessionId);
  }

  private withSession<T>(payload: T): T & { sessionId: string } {
    return { ...payload, sessionId: this.tabSessionId };
  }

  onClickPopUp(): void {
    const showHeader = false;
    const isPopUp = true;
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate("itineraries.addEditItinerary.modals.addCustomer"),
        nzWidth: "530px",
        nzContent: AddEditCustomerComponent,
        nzFooter: null,
        nzComponentParams: {
          showHeader,
          isPopUp
        },
      })
      .afterClose.subscribe(data => {
      if (data !== undefined) {
        if (data.message === "success") {
          this.getActiveCustomers().then(() => {
            this.tourForm.patchValue({customer: data.customer});
          });
        }
      }
    });
  }

  onChangeSwitch(event: boolean , index: number): void {
    this.singleItinerary.days[index].isLeisureDay = event;
  }

  onChangeMergeToggle(event: boolean , index: number): void {
    this.loadingService.start();
    this.singleItinerary.days[index].isMerged = event;
    this.updateLeisureDay().then(() => {
      this.loadingService.stop();
    });
  }

 async onOpenRemarksModal(currentTitle: string, lang: string): Promise<void> {
   const language = this.languages?.find((l: any) => l.code === lang);
   this.nzModalService
   .create({
     nzTitle: this.translocoService.translate("itineraries.addEditItinerary.modals.editTitle"),
       nzWidth: "400px",
       nzContent: AddEditRemarksTitleComponent,
       nzFooter: null,
       nzComponentParams: {
         currentTitle,
         language
       },
     })
     .afterClose.subscribe(async data => {
     if (data !== undefined) {
       if (data.message === "success") {
         this.singleItinerary.days.forEach((day:any, index:number) => {
           this.singleItinerary.days[index].remarksTitle = data.title;
         });
         await this.updateItineraryContent();
       }
     }
   });
  }

  determineStatusLogic(): boolean {
    if (this.singleItinerary?.status === SETTINGS.ITINERARY_STATUSES.CONFIRMED){
      return true;
    }else if (this.singleItinerary?.status === SETTINGS.ITINERARY_STATUSES.INVOICE_SENT){
      return true;
    }else if (this.singleItinerary?.status === SETTINGS.ITINERARY_STATUSES.PAID){
      return true;
    }else{
      return false;
    }
  }

  get tableFG(): FormGroup {
    return this.costingForm.get('dynamicPricing') as FormGroup;
  }

  get headersFA() {
    return this.tableFG.get('headers') as FormArray<
      FormGroup<{
        name: FormControl<string>;
        isCostColumn: FormControl<boolean>;
      }>
    >;
  }

  get rowsFA(): FormArray<FormArray<FormControl<any>>> {
    return this.tableFG.get('rows') as FormArray<FormArray<FormControl<any>>>;
  }

  cellControl(r: number, c: number): FormControl<any> {
    return (this.rowsFA.at(r) as FormArray).at(c) as FormControl<any>;
  }

  // --- Add / Delete ---
  addRow(values?: Array<string | number>) {
    const cols = this.headersFA.length;

    const controls = Array.from({ length: cols }, (_, i) => {
      const headerGroup = this.headersFA.at(i) as FormGroup;
      const isCostColumn = headerGroup.get('isCostColumn')?.value as boolean | undefined;

      const cell =
        values?.[i] ??
        (i === 0
          ? ''
          : isCostColumn
            ? '0.00'
            : '-');

      return this.fb.control(cell);
    });
    const newRow = this.fb.array<FormControl<any>>(controls);
    this.rowsFA.push(newRow);
  }

  deleteRow(index: number) {
    if (this.rowsFA.length > 1) this.rowsFA.removeAt(index);
  }

  addColumn(colName: string, isCost: boolean) {
    this.headersFA.push(
      this.fb.nonNullable.group({
        name: this.fb.nonNullable.control(colName),
        isCostColumn: this.fb.nonNullable.control(isCost)
      })
    );
    if (isCost){
      this.rowsFA.controls.forEach((rowFA) => rowFA.push(this.fb.control('0.00')));
    }else{
      this.rowsFA.controls.forEach((rowFA) => rowFA.push(this.fb.control('-')));
    }

  }

  deleteColumn(index: number) {
    // Keep at least 2 columns (Pax + 1)
    if (index === 0) return;
    if (this.headersFA.length <= 1) return;
    this.headersFA.removeAt(index);
    this.rowsFA.controls.forEach((rowFA) => rowFA.removeAt(index));
  }

  // Format numeric to 2dp
  toTwoDp(r: number, c: number) {
    if (c === 0) return;
    const val = this.cellControl(r, c).value;
    if (val === '' || isNaN(+val)) return;
    this.cellControl(r, c).setValue(Number(val).toFixed(2));
  }

  defaultDynamicValues():void {
    this.headersFA.push(
      this.fb.nonNullable.group({
        name: this.fb.nonNullable.control(this.t("itineraries.addEditItinerary.seasonalPricing.defaultColumns.paxRange")),
        isCostColumn: this.fb.nonNullable.control(false)
      })
    );

    this.headersFA.push(
      this.fb.nonNullable.group({
        name: this.fb.nonNullable.control(this.t("itineraries.addEditItinerary.seasonalPricing.defaultColumns.lowSeason")),
        isCostColumn: this.fb.nonNullable.control(true)
      })
    );

    this.headersFA.push(
      this.fb.nonNullable.group({
        name: this.fb.nonNullable.control(this.t("itineraries.addEditItinerary.seasonalPricing.defaultColumns.highSeason")),
        isCostColumn: this.fb.nonNullable.control(true)
      })
    );
    this.addRow(['1-2', '0.00', '0.00']);
    this.addRow(['3-5', '0.00', '0.00']);
  }

  addDynamicPricingData(headers: string[], rows: string[][]) {
    headers.forEach((header:any) => {
      this.headersFA.push(
        this.fb.nonNullable.group({
          name: this.fb.nonNullable.control(header.name),
          isCostColumn: this.fb.nonNullable.control(header.isCostColumn)
        })
      );
    });
    rows.forEach(rowValues => {
      this.addRow(rowValues);
    });
  }

  generateSimpleWord(): void {
    this.loadingService.start();
    let mapUrl: any = null;
    Promise.all([this.loadItineraryByID()]).then(async () => {
      mapUrl = this.singleItinerary.viewSettings.mapType === SETTINGS.MAP_TYPES[0].value ?  await this.mapDirectionsImage() : this.mapImage();
      const countryImageURL = this.singleItinerary?.tour?.customer?.country?.code ?
        this.findCountryFlagImage(this.singleItinerary?.tour.customer.country.code) : "";
      const b2b = this.singleItinerary?.tour?.type === "B2B" ? {
        itinerary: this.singleItinerary?.itinerary,
        companyName: this.singleItinerary?.b2b?.customer?.companyName || "",
        logo: this.singleItinerary?.b2b?.customer?.logo,
        costing: this.singleItinerary?.b2b?.costing,
        companyDetails: {summary: this.singleItinerary?.b2b?.customer?.summary || "" , websiteLink: this.singleItinerary?.b2b?.customer?.websiteLink || ""},
      } : "";
      const payload = {
        day: this.singleItinerary.days.length,
        night: this.singleItinerary.days.length - 1,
        clientTimezoneOffset: new Date().getTimezoneOffset(),
        ...this.singleItinerary,
        ...this.brand,
        citiesByCountry: this.citiesByCountry,
        countries: this.countries,
        mapURL: mapUrl,
        countryImageURL,
        ...b2b
      };
      this.wordReportService.generateWordReport(payload).then((res) => {
        const fileName = `${this.singleItinerary.tour.referenceNo}-${this.singleItinerary?.b2b?.customer?.companyName ? this.singleItinerary?.b2b?.customer?.companyName : this.getNoNameFallback()} `;
        this.wordReportService.downloadDocxReport(res, fileName);
        this.loadingService.stop();
      });
    });
  }

  seasonalPricingConfirmModal(): void {
    if (this.seasonPricingType === 'new') {
      this.addColumn(this.seasonPricingColName, this.isCostColumn);
    }else{
      if (this.headerIndex != null) {
        (this.headersFA.at(this.headerIndex) as FormGroup)
          .patchValue({ name: this.seasonPricingColName, isCostColumn: this.isCostColumn });
      }
    }
    this.seasonPricingIsVisible = false;
    this.seasonPricingColName = '';
    this.seasonPricingType='';
    this.headerIndex = null
  }

  seasonalPricingOpenModal(type: string, index: number | null): void {
    this.seasonPricingIsVisible = true;
    this.seasonPricingType = type;
    this.headerIndex = index

    if (this.seasonPricingType !== 'new'){
      if (index !== null){
        const headerGroup = this.headersFA.at(index) as FormGroup;
        const isCostColumn = headerGroup.get('isCostColumn')?.value;
        const headerName = headerGroup.get('name')?.value;
        this.seasonPricingColName = headerName;
        this.isCostColumn = isCostColumn;
      }
    }
  }

  seasonalPricingCancel(): void {
    this.seasonPricingIsVisible = false;
    this.seasonPricingColName = '';
    this.seasonPricingType='';
    this.headerIndex = null
  }

  private migrateLegacyAdditionalNotesTable(notes: any): string {
    const headers = notes?.table?.headers ?? [];
    const rows = notes?.table?.rows ?? [];
    if (!headers.length && !rows.length) {
      return notes?.content ?? "";
    }

    const thead = headers.length
      ? `<thead><tr>${headers.map((header: any) => `<th>${header?.name ?? ""}</th>`).join("")}</tr></thead>`
      : "";
    const tbody = rows.length
      ? `<tbody>${rows
          .map(
            (row: string[]) =>
              `<tr>${(row ?? [])
                .map((cell) => {
                  const value = String(cell ?? "").trim();
                  return `<td>${value || "-"}</td>`;
                })
                .join("")}</tr>`,
          )
          .join("")}</tbody>`
      : "";

    return `<table>${thead}${tbody}</table>`;
  }

  setAdditionalNotesContent(): void {
    const notes = this.singleItinerary?.additionalNotes ?? {};
    const content =
      notes.format === "table"
        ? this.migrateLegacyAdditionalNotesTable(notes)
        : notes.content || "";

    this.additionalNotesForm.patchValue({
      title: notes.title || "Additional Notes",
      content,
    });
  }

  buildAdditionalNotesPayload(): any {
    const raw = this.additionalNotesForm.getRawValue();
    return {
      title: raw.title,
      content: raw.content || "",
    };
  }

  async onOpenAdditionalNotesTitleModal(currentTitle: string, lang: string): Promise<void> {
    const language = this.languages?.find((l: any) => l.code === lang);
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate("itineraries.addEditItinerary.modals.editTitle"),
        nzWidth: "400px",
        nzContent: AddEditRemarksTitleComponent,
        nzFooter: null,
        nzComponentParams: {
          currentTitle,
          language,
          fieldLabelKey: "itineraries.addEditItinerary.additionalNotes.titleLabel",
          placeholderKey: "itineraries.addEditItinerary.additionalNotes.enterTitle",
        },
      })
      .afterClose.subscribe((data) => {
        if (data?.message === "success") {
          this.additionalNotesForm.patchValue({ title: data.title });
        }
      });
  }

  async translateContent(content: string, language: string, type: string): Promise<void> {
    this.loadingService.start();
      const payload = `
        You are a translation engine.

        Translate the text content inside the provided HTML into '${language}'.

        Rules:
        - Preserve all HTML tags exactly.
        - Do not modify HTML structure or attributes.
        - Only translate text nodes.
        - Do not add comments or explanations.
        - Output format: plain text HTML only.
        - Never use markdown or code blocks.

        HTML:
        ${content}
        `;
      try {
        const value = await this.openAiService.askChatGPT({query: payload});
        if (value) {
          const newContent = value.choices[0].message.content;
          if (type === 'inclusions') {
            this.itineraryForm.patchValue({ inclusions: newContent });
          } else if (type === 'exclusions') {
            this.itineraryForm.patchValue({ exclusions: newContent });
          } else if (type === 'policies') {
            this.itineraryForm.patchValue({ policies: newContent });
          } else if (type === 'pricingRemarks') {
            this.costingForm.patchValue({ pricingRemarks: newContent });
          }
        }
        this.loadingService.stop();
      } catch (error) {
        this.loadingService.stop();
      }
  }


  initializeAddTour(): void {
      this.addItineraryTour = driver({
        showProgress: true,
        allowClose: false,
        animate: true,
        popoverClass: 'travsta-tour-popup',
        steps: this.getTourGuideSteps("add"),
        onPopoverRender: (popover, { driver }) => {
          const existingSkipBtn = popover.footerButtons.querySelector('.custom-skip-tour');
          if (!existingSkipBtn) {
            const skipBtn = this.createSkipTourButton(driver);
            popover.footerButtons.prepend(skipBtn);
          }
        }
      });
    }

    initializeEditTour(): void {
      this.editItineraryTour = driver({
        showProgress: true,
        allowClose: false,
        animate: true,
        popoverClass: 'travsta-tour-popup',
        steps: this.getTourGuideSteps("edit"),

        onPopoverRender: (popover, { driver }) => {
          const existingSkipBtn = popover.footerButtons.querySelector('.custom-skip-tour');

          if (!existingSkipBtn) {
            const skipBtn = this.createSkipTourButton(driver);
            popover.footerButtons.prepend(skipBtn);
          }
        },

          onDestroyed: () => {
            this.removeTourParam();
          }
      });
    }

    removeTourParam(): void {
      this.isTour = false;
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { tour: null },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }

  private t(key: string, params?: Record<string, unknown>): string {
    return this.translocoService.translate(key, params);
  }

  private getNoNameFallback(): string {
    return this.t("itineraries.addEditItinerary.fallbacks.noName");
  }

  private getTourGuideSteps(type: "add" | "edit"): Array<any> {
    if (type === "add") {
      return [
        {
          popover: {
            title: this.t("itineraries.addEditItinerary.tourGuide.add.steps.welcome.title"),
            description: this.t("itineraries.addEditItinerary.tourGuide.add.steps.welcome.description"),
            nextBtnText: this.t("itineraries.addEditItinerary.tourGuide.actions.startTour")
          }
        },
        {
          element: "#tour-information-section",
          popover: {
            title: this.t("itineraries.addEditItinerary.tourGuide.add.steps.basics.title"),
            description: this.t("itineraries.addEditItinerary.tourGuide.add.steps.basics.description"),
            nextBtnText: this.t("itineraries.addEditItinerary.tourGuide.actions.next")
          }
        },
        {
          element: "#next-button",
          popover: {
            title: this.t("itineraries.addEditItinerary.tourGuide.add.steps.nextButton.title"),
            description: this.t("itineraries.addEditItinerary.tourGuide.add.steps.nextButton.description"),
            nextBtnText: this.t("itineraries.addEditItinerary.tourGuide.actions.gotIt")
          }
        }
      ];
    }

    return [
      {
        popover: {
          title: this.t("itineraries.addEditItinerary.tourGuide.edit.steps.welcome.title"),
          description: this.t("itineraries.addEditItinerary.tourGuide.edit.steps.welcome.description"),
          nextBtnText: this.t("itineraries.addEditItinerary.tourGuide.actions.startTour")
        }
      },
      {
        element: "#itinerary-title",
        popover: {
          title: this.t("itineraries.addEditItinerary.tourGuide.edit.steps.itineraryTitle.title"),
          description: this.t("itineraries.addEditItinerary.tourGuide.edit.steps.itineraryTitle.description"),
          nextBtnText: this.t("itineraries.addEditItinerary.tourGuide.actions.next")
        }
      },
      {
        element: "#plan-days-section",
        popover: {
          title: this.t("itineraries.addEditItinerary.tourGuide.edit.steps.planDays.title"),
          description: this.t("itineraries.addEditItinerary.tourGuide.edit.steps.planDays.description"),
          nextBtnText: this.t("itineraries.addEditItinerary.tourGuide.actions.next")
        }
      },
      {
        element: "#cost-details-section",
        popover: {
          title: this.t("itineraries.addEditItinerary.tourGuide.edit.steps.costDetails.title"),
          description: this.t("itineraries.addEditItinerary.tourGuide.edit.steps.costDetails.description"),
          nextBtnText: this.t("itineraries.addEditItinerary.tourGuide.actions.next")
        }
      },
      {
        element: "#overview-section",
        popover: {
          title: this.t("itineraries.addEditItinerary.tourGuide.edit.steps.overview.title"),
          description: this.t("itineraries.addEditItinerary.tourGuide.edit.steps.overview.description"),
          nextBtnText: this.t("itineraries.addEditItinerary.tourGuide.actions.next")
        }
      },
      {
        element: "#inclusions-section",
        popover: {
          title: this.t("itineraries.addEditItinerary.tourGuide.edit.steps.inclusions.title"),
          description: this.t("itineraries.addEditItinerary.tourGuide.edit.steps.inclusions.description"),
          nextBtnText: this.t("itineraries.addEditItinerary.tourGuide.actions.next")
        }
      },
      {
        element: "#update-button",
        popover: {
          title: this.t("itineraries.addEditItinerary.tourGuide.edit.steps.saveShare.title"),
          description: this.t("itineraries.addEditItinerary.tourGuide.edit.steps.saveShare.description"),
          nextBtnText: this.t("itineraries.addEditItinerary.tourGuide.actions.okayGotIt")
        }
      }
    ];
  }

  private createSkipTourButton(driverInstance: Driver): HTMLButtonElement {
    const skipBtn = document.createElement("button");
    skipBtn.innerText = this.t("itineraries.addEditItinerary.tourGuide.actions.skipTour");
    skipBtn.className = "custom-skip-tour";

    skipBtn.style.marginRight = "auto";
    skipBtn.style.background = "transparent";
    skipBtn.style.border = "none";
    skipBtn.style.color = "#6b7280";
    skipBtn.style.cursor = "pointer";
    skipBtn.style.fontSize = "14px";

    skipBtn.onclick = () => {
      driverInstance.destroy();
      this.removeTourParam();
    };

    return skipBtn;
  }

  /**
   * Strips top-level _id fields from objects in an array (or a single object)
   * to avoid conflicts when creating a new itinerary from template data.
   * Unlike deep stripping, this preserves reference IDs inside nested objects
   * (e.g. experience._id inside experiencesPerDay items).
   */
  private stripTopLevelIds(data: any): any {
    if (Array.isArray(data)) {
      return data.map(({ _id, ...rest }: any) => rest);
    }
    if (data && typeof data === 'object') {
      const { _id, ...rest } = data;
      return rest;
    }
    return data;
  }

  formatter = currencyFormatter;
  parser = amountParser;
}
